@import "tailwindcss";

:root {
  --ink: #122f2c;
  --ink-soft: #49645f;
  --paper: #f7f6ef;
  --white: #fffef9;
  --mint: #dfeee7;
  --teal: #0b756c;
  --teal-dark: #07574f;
  --coral: #d96b4d;
  --amber: #e9bc65;
  --line: #cfdbd4;
  --serif: Georgia, "Times New Roman", serif;
  --sans: Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.brucei-audit-section {
  padding-top: 58px;
}

.provenance-layer-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.provenance-layer-grid article {
  min-height: 170px;
  padding: 25px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.provenance-layer-grid span,
.brucei-boundary-note > span,
.author-atlas-facts span,
.archive-checksum span,
.audit-manifest-note span {
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.provenance-layer-grid strong {
  display: block;
  margin-top: 38px;
  font: 400 25px/1.15 var(--serif);
}

.provenance-layer-grid p {
  margin: 8px 0 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.brucei-boundary-note {
  margin: 28px 0 54px;
  padding: 36px;
  border-left: 4px solid var(--coral);
  background: rgba(217, 107, 77, 0.08);
}

.brucei-boundary-note h2 {
  margin: 12px 0 8px;
  font: 400 34px/1.15 var(--serif);
}

.brucei-boundary-note p {
  max-width: 980px;
  margin: 0;
  color: var(--ink-soft);
}

.brucei-audit-block {
  margin-top: 24px;
  border: 1px solid var(--line);
  background: var(--white);
}

.brucei-audit-block > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;
  padding: 30px;
  border-bottom: 1px solid var(--line);
}

.brucei-audit-block > header h2 {
  margin: 0;
  font: 400 30px/1.15 var(--serif);
}

.brucei-audit-block > header > span,
.brucei-audit-block > header > a {
  color: var(--ink-soft);
  font-size: 10px;
}

.brucei-audit-block > header > a {
  border-bottom: 1px solid rgba(18, 47, 44, 0.35);
}

.audit-block-intro {
  max-width: 1060px;
  margin: 0;
  padding: 24px 30px;
  color: var(--ink-soft);
  font-size: 11px;
}

.ena-run-list {
  border-top: 1px solid var(--line);
}

.ena-run-list > article {
  display: grid;
  grid-template-columns: 260px 1fr;
  border-bottom: 1px solid var(--line);
}

.ena-run-list > article > header {
  padding: 24px 30px;
  border-right: 1px solid var(--line);
}

.ena-run-list > article > header span {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
}

.ena-run-list h3 {
  margin: 8px 0 0;
  font: 400 23px/1 var(--serif);
}

.ena-run-list > article > header p {
  margin: 10px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.ena-run-list > article > div {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.ena-run-list a {
  min-width: 0;
  padding: 24px;
  border-right: 1px solid var(--line);
}

.ena-run-list a:last-child {
  border-right: 0;
}

.ena-run-list a span,
.ena-run-list a strong,
.ena-run-list a small {
  display: block;
}

.howick-run-facts {
  grid-template-columns: minmax(150px, 0.45fr) 1fr !important;
}

.howick-run-facts > div,
.howick-run-facts > p {
  min-width: 0;
  margin: 0;
  padding: 24px;
  border-right: 1px solid var(--line);
}

.howick-run-facts > p {
  border-right: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.howick-run-facts span,
.howick-run-facts strong,
.howick-run-facts small {
  display: block;
}

.howick-run-facts span {
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
}

.howick-run-facts strong {
  margin-top: 8px;
  font: 400 24px/1 var(--serif);
}

.howick-run-facts small {
  margin-top: 9px;
  color: var(--ink-soft);
  font-size: 8px;
}

.ena-run-list a span {
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
}

.ena-run-list a strong {
  margin-top: 8px;
  overflow-wrap: anywhere;
  font-size: 11px;
}

.ena-run-list a small {
  margin-top: 9px;
  color: var(--ink-soft);
  font-size: 8px;
  overflow-wrap: anywhere;
}

.audit-manifest-note {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  padding: 20px 30px;
  background: var(--mint);
}

.audit-manifest-note code {
  font-size: 9px;
  overflow-wrap: anywhere;
}

.audit-manifest-note p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.matrix-audit-table {
  display: grid;
}

.matrix-audit-table > div {
  display: grid;
  grid-template-columns: 1.8fr repeat(3, 0.8fr);
  border-bottom: 1px solid var(--line);
}

.matrix-audit-table > div > * {
  min-width: 0;
  padding: 18px 24px;
  border-right: 1px solid var(--line);
  font-size: 10px;
}

.matrix-audit-table > div > *:last-child {
  border-right: 0;
}

.matrix-audit-table strong small {
  display: block;
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 8px;
  font-weight: 400;
}

.matrix-audit-head {
  background: var(--ink);
  color: var(--white);
}

.matrix-audit-head span {
  font-size: 8px !important;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.archive-checksum {
  display: grid;
  grid-template-columns: 1.6fr 0.6fr 1.4fr;
  border-bottom: 1px solid var(--line);
}

.archive-checksum > div {
  min-width: 0;
  padding: 22px 24px;
  border-right: 1px solid var(--line);
}

.archive-checksum > div:last-child {
  border-right: 0;
}

.archive-checksum strong,
.archive-checksum code {
  display: block;
  margin-top: 7px;
  font-size: 10px;
  overflow-wrap: anywhere;
}

.matrix-boundary {
  margin: 0;
  padding: 20px 24px;
  color: var(--ink-soft);
  font-size: 10px;
}

.author-atlas-facts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid var(--line);
}

.author-atlas-facts article {
  padding: 27px;
  border-right: 1px solid var(--line);
}

.author-atlas-facts article:last-child {
  border-right: 0;
}

.author-atlas-facts strong {
  display: block;
  margin-top: 13px;
  font: 400 30px/1 var(--serif);
}

.author-atlas-facts p {
  margin: 8px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.atlas-boundary-copy {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-bottom: 1px solid var(--line);
}

.atlas-boundary-copy p {
  margin: 0;
  padding: 24px;
  border-right: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 10px;
}

.atlas-boundary-copy p:last-child {
  border-right: 0;
}

.record-source-links {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 26px;
  margin-top: 30px;
  padding: 25px 0;
}

.record-source-links a {
  border-bottom: 1px solid rgba(18, 47, 44, 0.35);
  color: var(--ink-soft);
  font-size: 11px;
  font-weight: 800;
}

@media (max-width: 900px) {
  .provenance-layer-grid,
  .author-atlas-facts {
    grid-template-columns: repeat(2, 1fr);
  }

  .ena-run-list > article {
    grid-template-columns: 1fr;
  }

  .ena-run-list > article > header {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }
}

@media (max-width: 640px) {
  .provenance-layer-grid,
  .author-atlas-facts,
  .ena-run-list > article > div,
  .howick-run-facts,
  .atlas-boundary-copy,
  .archive-checksum {
    grid-template-columns: 1fr;
  }

  .brucei-audit-block > header {
    flex-direction: column;
  }

  .matrix-audit-table {
    overflow-x: auto;
  }

  .matrix-audit-table > div {
    min-width: 680px;
  }

  .audit-manifest-note {
    grid-template-columns: 1fr;
  }
}

* {
  box-sizing: border-box;
}

.skip-link {
  position: fixed;
  z-index: 10000;
  top: 0.75rem;
  left: 0.75rem;
  padding: 0.7rem 1rem;
  border-radius: 0.35rem;
  background: #fff;
  color: #123f3b;
  box-shadow: 0 0 0 3px #25a8a3;
  transform: translateY(-180%);
}

.skip-link:focus {
  transform: translateY(0);
}

html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  background: var(--paper);
  color: var(--ink);
  font-family: var(--sans);
  line-height: 1.55;
}

a {
  color: inherit;
  text-decoration: none;
}

button,
input {
  font: inherit;
}

.site-header {
  position: sticky;
  z-index: 20;
  top: 0;
  border-bottom: 1px solid rgba(18, 47, 44, 0.12);
  background: rgba(247, 246, 239, 0.94);
  backdrop-filter: blur(16px);
}

.header-inner {
  display: grid;
  grid-template-columns: minmax(230px, 1fr) auto minmax(230px, 1fr);
  align-items: center;
  width: min(1440px, calc(100% - 64px));
  min-height: 82px;
  margin: 0 auto;
  gap: 28px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  width: fit-content;
}

.brand-mark {
  display: grid;
  width: 43px;
  height: 43px;
  border-radius: 50%;
  background: var(--ink);
  color: var(--paper);
  font: italic 700 25px/1 var(--serif);
  place-items: center;
}

.brand strong,
.brand small {
  display: block;
}

.brand strong {
  letter-spacing: -0.02em;
  font-family: var(--serif);
  font-size: 20px;
}

.brand small {
  color: var(--ink-soft);
  font-size: 10px;
  letter-spacing: 0.04em;
}

.main-nav {
  display: flex;
  align-items: center;
  gap: 28px;
  white-space: nowrap;
}

.main-nav a {
  position: relative;
  font-size: 13px;
  font-weight: 700;
}

.main-nav a::after {
  position: absolute;
  right: 0;
  bottom: -7px;
  left: 0;
  height: 2px;
  background: var(--coral);
  content: "";
  opacity: 0;
  transform: scaleX(0.5);
  transition: 180ms ease;
}

.main-nav a:hover::after,
.main-nav a:focus-visible::after {
  opacity: 1;
  transform: scaleX(1);
}

.header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
}

.verified-label {
  color: var(--ink-soft);
  font-size: 11px;
  white-space: nowrap;
}

.verified-label span {
  color: var(--teal);
}

.language-toggle {
  min-width: 48px;
  padding: 7px 10px;
  border: 1px solid var(--ink);
  border-radius: 999px;
  background: transparent;
  color: var(--ink);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}

.hero {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(360px, 0.95fr);
  width: min(1440px, calc(100% - 64px));
  min-height: 690px;
  margin: 0 auto;
  align-items: center;
  gap: clamp(48px, 7vw, 110px);
  padding: 72px 0 54px;
}

.hero-copy {
  max-width: 720px;
}

.eyebrow,
.section-number {
  margin: 0 0 18px;
  color: var(--teal);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.17em;
  text-transform: uppercase;
}

.hero h1,
.page-hero h1 {
  max-width: 780px;
  margin: 0;
  font-family: var(--serif);
  font-size: clamp(54px, 6.4vw, 94px);
  font-weight: 400;
  letter-spacing: -0.055em;
  line-height: 0.99;
}

.hero-lede,
.page-hero > h1 + p {
  max-width: 710px;
  margin: 30px 0 0;
  color: var(--ink-soft);
  font-size: 18px;
  line-height: 1.8;
}

.hero-actions,
.atlas-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 34px;
}

.button {
  display: inline-flex;
  min-height: 48px;
  align-items: center;
  justify-content: center;
  padding: 0 21px;
  border: 1px solid var(--ink);
  border-radius: 4px;
  font-size: 13px;
  font-weight: 800;
  transition: 160ms ease;
}

.button:hover,
.button:focus-visible {
  transform: translateY(-2px);
}

.button-primary {
  background: var(--ink);
  color: var(--white);
}

.button-secondary {
  background: transparent;
}

.button-light {
  border-color: var(--white);
  background: var(--white);
  color: var(--ink);
}

.evidence-note {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 24px;
  color: var(--ink-soft);
  font-size: 12px;
}

.evidence-dot {
  width: 8px;
  height: 8px;
  border: 2px solid var(--teal);
  border-radius: 50%;
}

.hero-figure {
  position: relative;
  margin: 0;
  padding: 22px 22px 0;
  background:
    linear-gradient(rgba(255, 254, 249, 0.22) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 254, 249, 0.22) 1px, transparent 1px),
    var(--teal-dark);
  background-size: 34px 34px;
}

.hero-figure::before {
  position: absolute;
  z-index: 1;
  top: -16px;
  right: -16px;
  width: 90px;
  height: 90px;
  border: 1px solid var(--coral);
  border-radius: 50%;
  content: "";
}

.hero-figure img {
  position: relative;
  z-index: 2;
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  filter: saturate(0.72) contrast(1.08);
  object-fit: cover;
}

.hero-figure figcaption {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 0 16px;
  color: #d7eae4;
  font-size: 10px;
}

.hero-figure figcaption a {
  text-align: right;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.metrics {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.metrics > div {
  display: flex;
  min-height: 126px;
  align-items: baseline;
  justify-content: center;
  gap: 10px;
  padding: 28px;
  border-right: 1px solid var(--line);
}

.metrics > div:last-child {
  border-right: 0;
}

.metrics strong {
  font-family: var(--serif);
  font-size: 38px;
  font-weight: 400;
}

.metrics span {
  color: var(--ink-soft);
  font-size: 12px;
}

.section {
  width: min(1440px, calc(100% - 64px));
  margin: 0 auto;
  padding: 110px 0;
}

.section-heading {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  align-items: end;
  gap: 64px;
  margin-bottom: 50px;
}

.section-heading h2,
.host-panel h2,
.chagas-source-card h2 {
  max-width: 780px;
  margin: 0;
  font-family: var(--serif);
  font-size: clamp(38px, 4.8vw, 66px);
  font-weight: 400;
  letter-spacing: -0.045em;
  line-height: 1.05;
}

.section-heading > p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 15px;
  line-height: 1.75;
}

.species-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.species-card {
  position: relative;
  overflow: hidden;
  min-height: 430px;
  padding: 38px;
  border: 1px solid var(--line);
  background: var(--white);
}

.species-live {
  padding-right: 160px;
}

.species-code {
  display: grid;
  width: 76px;
  height: 76px;
  border: 1px solid currentColor;
  border-radius: 50%;
  color: var(--teal);
  font: italic 400 25px/1 var(--serif);
  place-items: center;
}

.species-status {
  margin: 28px 0 12px;
  color: var(--teal);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.14em;
}

.species-card h3,
.atlas-card h2 {
  margin: 0;
  font-family: var(--serif);
  font-size: 34px;
  font-weight: 400;
}

.species-card > p:not(.species-status) {
  max-width: 560px;
  color: var(--ink-soft);
}

.species-card > a {
  position: absolute;
  bottom: 36px;
  border-bottom: 1px solid var(--ink);
  font-size: 13px;
  font-weight: 800;
}

.species-facts {
  display: flex;
  gap: 20px;
  margin-top: 30px;
  color: var(--ink-soft);
  font-family: var(--serif);
}

.species-live::after {
  position: absolute;
  top: 38px;
  right: -62px;
  width: 190px;
  height: 360px;
  border: 1px solid rgba(11, 117, 108, 0.28);
  border-radius: 50%;
  content: "";
  transform: rotate(18deg);
}

.cruzi-card::after {
  border-color: rgba(217, 107, 77, 0.34);
  transform: rotate(-12deg);
}

.gap-card {
  grid-column: 1 / -1;
  min-height: auto;
  background: var(--mint);
}

.gap-card h3 {
  font-size: 30px;
}

.gap-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 28px 0;
}

.gap-list span {
  padding: 8px 12px;
  border: 1px solid rgba(18, 47, 44, 0.22);
  border-radius: 99px;
  font: italic 14px/1 var(--serif);
}

.lifecycle-section {
  border-top: 1px solid var(--line);
}

.lifecycle-track {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  background: var(--ink);
  color: var(--white);
}

.lifecycle-step {
  min-height: 220px;
  padding: 30px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
}

.lifecycle-step:last-child {
  border-right: 0;
}

.lifecycle-step > span {
  color: #92bdb5;
  font-size: 11px;
}

.lifecycle-step h3 {
  margin: 44px 0 30px;
  font: 400 22px/1.2 var(--serif);
}

.track-line {
  overflow: hidden;
  height: 3px;
  background: rgba(255, 255, 255, 0.13);
}

.track-line i {
  display: block;
  height: 100%;
  background: var(--coral);
}

.field-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 22px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.field-grid > div {
  min-height: 102px;
  padding: 23px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.field-grid span,
.field-grid small {
  display: block;
}

.field-grid span {
  font: 18px/1.2 var(--serif);
}

.field-grid small {
  margin-top: 8px;
  color: var(--ink-soft);
}

.host-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(320px, 0.8fr);
  gap: 80px;
  padding: clamp(40px, 6vw, 82px);
  background: var(--teal-dark);
  color: var(--white);
}

.host-panel > div:first-child > p:last-of-type {
  max-width: 700px;
  color: #cfe1dc;
  line-height: 1.8;
}

.host-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.host-stats > div {
  min-height: 135px;
  padding: 22px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.host-stats strong,
.host-stats span {
  display: block;
}

.host-stats strong {
  font: 400 42px/1 var(--serif);
}

.host-stats span {
  margin-top: 14px;
  color: #cfe1dc;
  font-size: 11px;
}

.host-stats > small {
  grid-column: 1 / -1;
  padding: 18px 20px;
  color: #a9c7c0;
  line-height: 1.6;
}

.trust-section {
  border-top: 1px solid var(--line);
}

.trust-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.trust-grid article {
  min-height: 280px;
  padding: 34px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.trust-grid article > span {
  color: var(--coral);
  font: 28px/1 var(--serif);
}

.trust-grid h3 {
  margin: 56px 0 18px;
  font: 400 25px/1.15 var(--serif);
}

.trust-grid p {
  color: var(--ink-soft);
  font-size: 14px;
}

.page-hero {
  width: min(1440px, calc(100% - 64px));
  margin: 0 auto;
  padding: 112px 0 86px;
  border-bottom: 1px solid var(--line);
}

.page-hero h1 {
  max-width: 1050px;
  font-size: clamp(52px, 6vw, 88px);
}

.catalogue-section {
  padding-top: 58px;
}

.catalogue-tools {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) auto;
  gap: 18px;
}

.search-field {
  display: flex;
  min-height: 52px;
  align-items: center;
  gap: 12px;
  padding: 0 18px;
  border: 1px solid var(--line);
  background: var(--white);
}

.search-field input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--ink);
}

.segmented {
  display: flex;
  padding: 4px;
  border: 1px solid var(--line);
  background: var(--white);
}

.segmented button {
  padding: 10px 14px;
  border: 0;
  background: transparent;
  color: var(--ink-soft);
  cursor: pointer;
  font-size: 12px;
}

.segmented button.active {
  background: var(--ink);
  color: var(--white);
}

.catalogue-count {
  margin: 34px 0 14px;
  color: var(--ink-soft);
  font-size: 12px;
}

.catalogue-count strong {
  color: var(--ink);
  font: 25px/1 var(--serif);
}

.dataset-list {
  border-top: 1px solid var(--line);
}

.dataset-card {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr) 160px;
  gap: 28px;
  padding: 34px 0;
  border-bottom: 1px solid var(--line);
}

.dataset-index {
  display: grid;
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: var(--mint);
  color: var(--teal-dark);
  font: italic 17px/1 var(--serif);
  place-items: center;
}

.dataset-kicker {
  display: flex;
  flex-wrap: wrap;
  gap: 9px 18px;
  color: var(--ink-soft);
  font-size: 11px;
}

.dataset-main h2 {
  margin: 11px 0 8px;
  font: 400 28px/1.2 var(--serif);
}

.dataset-stages {
  margin: 0;
  color: var(--teal-dark);
  font-size: 13px;
}

.dataset-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
}

.dataset-meta span {
  padding: 7px 10px;
  border: 1px solid var(--line);
  background: rgba(255, 254, 249, 0.55);
  font-size: 11px;
}

.dataset-count-basis {
  max-width: 900px;
  margin: 12px 0 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.dataset-count-basis strong {
  color: var(--ink);
}

.catalogue-audit-links {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
  margin-bottom: 34px;
}

.catalogue-audit-links a {
  min-height: 112px;
  padding: 24px 26px;
  border: 1px solid var(--line);
  background: var(--white);
}

.catalogue-audit-links span,
.catalogue-audit-links strong {
  display: block;
}

.catalogue-audit-links span {
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.catalogue-audit-links strong {
  margin-top: 14px;
  font: 400 20px/1.35 var(--serif);
}

.audit-summary-section,
.comparison-section {
  padding-top: 58px;
}

.audit-policy {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.audit-policy > div {
  min-height: 230px;
  padding: 30px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.audit-policy > div > span {
  color: var(--coral);
  font: 400 24px/1 var(--serif);
}

.audit-policy h2 {
  margin: 46px 0 12px;
  font: 400 25px/1.15 var(--serif);
}

.audit-policy p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 12px;
}

.audit-record-list {
  margin-top: 58px;
}

.audit-record {
  margin-bottom: 22px;
  border: 1px solid var(--line);
  background: var(--white);
}

.audit-record > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;
  padding: 30px;
  border-bottom: 1px solid var(--line);
}

.audit-record > header > div {
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  gap: 5px 16px;
}

.audit-record > header p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.audit-record > header h2 {
  grid-column: 2;
  margin: 0;
  font: 400 30px/1.1 var(--serif);
}

.audit-index {
  grid-row: 1 / 3;
  color: var(--teal);
  font: italic 400 31px/1 var(--serif);
}

.audit-verdict {
  padding: 7px 10px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.audit-verdict.verified {
  background: var(--mint);
  color: var(--teal-dark);
}

.audit-verdict.scoped {
  background: rgba(233, 188, 101, 0.24);
  color: #80550f;
}

.audit-verdict.corrected {
  background: rgba(217, 107, 77, 0.14);
  color: #a43d24;
}

.audit-claims {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid var(--line);
}

.audit-claims > div {
  padding: 26px 30px;
  border-right: 1px solid var(--line);
}

.audit-claims > div:last-child {
  border-right: 0;
}

.audit-claims span {
  display: block;
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.09em;
}

.audit-claims strong {
  display: block;
  margin-top: 9px;
  font: 400 24px/1.25 var(--serif);
}

.audit-claims p {
  margin: 13px 0 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.audit-evidence {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.audit-evidence a {
  position: relative;
  min-height: 150px;
  padding: 24px 38px 24px 24px;
  border-right: 1px solid var(--line);
}

.audit-evidence a:last-child {
  border-right: 0;
}

.audit-evidence span {
  font-size: 11px;
  font-weight: 800;
}

.audit-evidence p {
  margin: 10px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.audit-evidence b {
  position: absolute;
  top: 23px;
  right: 20px;
  color: var(--coral);
}

.supplementary-audit {
  margin-top: 50px;
  padding: 38px;
  border: 1px solid var(--line);
  background: var(--mint);
}

.supplementary-audit h2 {
  max-width: 900px;
  margin: 0;
  font: 400 34px/1.15 var(--serif);
}

.supplementary-audit > p:not(.eyebrow) {
  max-width: 1040px;
  color: var(--ink-soft);
}

.supplementary-audit > div {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  margin-top: 24px;
}

.supplementary-audit a {
  border-bottom: 1px solid rgba(18, 47, 44, 0.35);
  font-size: 11px;
  font-weight: 800;
}

.comparison-warning {
  padding: 38px;
  border-left: 4px solid var(--coral);
  background: rgba(217, 107, 77, 0.08);
}

.comparison-warning > span {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.comparison-warning h2 {
  margin: 14px 0 10px;
  font: 400 32px/1.15 var(--serif);
}

.comparison-warning p {
  max-width: 980px;
  margin: 0;
  color: var(--ink-soft);
}

.comparison-table {
  margin-top: 32px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.comparison-row {
  display: grid;
  grid-template-columns: minmax(150px, 0.55fr) repeat(2, minmax(0, 1fr));
}

.comparison-row > div {
  min-width: 0;
  padding: 22px 24px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
  font-size: 11px;
}

.comparison-row > div:first-child {
  color: var(--teal-dark);
  font-weight: 800;
}

.comparison-head > div {
  background: var(--ink);
  color: var(--white);
  font-size: 9px;
  letter-spacing: 0.08em;
}

.comparison-head > div:first-child {
  color: #b9d7d1;
}

.comparison-head strong,
.comparison-head span {
  display: block;
}

.comparison-head strong {
  font: 400 20px/1.2 var(--serif);
  letter-spacing: normal;
}

.comparison-head span {
  margin-top: 7px;
  color: #b9d7d1;
  letter-spacing: normal;
}

.comparison-source-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 32px;
}

.comparison-source-grid article {
  padding: 32px;
  border: 1px solid var(--line);
  background: var(--white);
}

.comparison-source-grid h2 {
  margin: 0 0 24px;
  font: 400 28px/1.15 var(--serif);
}

.comparison-source-grid a {
  display: block;
  width: fit-content;
  margin-top: 11px;
  border-bottom: 1px solid rgba(18, 47, 44, 0.32);
  color: var(--ink-soft);
  font-size: 11px;
}

@media (max-width: 900px) {
  .catalogue-audit-links,
  .audit-policy,
  .comparison-source-grid {
    grid-template-columns: 1fr;
  }

  .audit-evidence {
    grid-template-columns: repeat(2, 1fr);
  }

  .audit-evidence a:nth-child(2n) {
    border-right: 0;
  }

  .audit-evidence a {
    border-bottom: 1px solid var(--line);
  }
}

@media (max-width: 640px) {
  .audit-record > header,
  .audit-claims {
    grid-template-columns: 1fr;
  }

  .audit-record > header {
    flex-direction: column;
  }

  .audit-claims > div {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .audit-claims > div:last-child {
    border-bottom: 0;
  }

  .audit-evidence {
    grid-template-columns: 1fr;
  }

  .audit-evidence a {
    border-right: 0;
  }

  .comparison-table {
    overflow-x: auto;
  }

  .comparison-row {
    min-width: 760px;
  }
}

.dataset-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  margin-top: 22px;
}

.dataset-links a,
.source-links a,
.atlas-actions > a:not(.button) {
  border-bottom: 1px solid rgba(18, 47, 44, 0.34);
  color: var(--ink-soft);
  font-size: 11px;
}

.dataset-links .primary-link {
  color: var(--teal-dark);
  font-weight: 800;
}

.dataset-links .records-link {
  color: var(--coral);
  font-weight: 800;
}

.dataset-status {
  display: flex;
  align-items: flex-start;
  padding-left: 24px;
  border-left: 1px solid var(--line);
  flex-direction: column;
}

.dataset-status span {
  display: grid;
  width: 28px;
  height: 28px;
  margin-bottom: 15px;
  border-radius: 50%;
  background: var(--teal);
  color: var(--white);
  place-items: center;
}

.dataset-status strong {
  font-size: 12px;
}

.dataset-status small {
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 10px;
}

.empty-state {
  padding: 70px 0;
  color: var(--ink-soft);
  text-align: center;
}

.provenance-banner {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 40px;
  margin-bottom: 110px;
  padding: 36px;
  background: var(--mint);
}

.provenance-banner p {
  max-width: 900px;
  margin: 8px 0 0;
  color: var(--ink-soft);
}

.provenance-banner a {
  font-size: 12px;
  font-weight: 800;
}

.atlas-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding-top: 58px;
}

.atlas-card {
  scroll-margin-top: 110px;
  padding: 42px;
  border: 1px solid var(--line);
  background: var(--white);
}

.atlas-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.source-badge {
  padding: 6px 9px;
  background: var(--mint);
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.atlas-card h2 {
  margin-top: 52px;
}

.atlas-zh {
  margin: 8px 0 0;
  color: var(--ink-soft);
}

.atlas-numbers {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 30px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.atlas-numbers > div {
  padding: 24px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.atlas-numbers strong,
.atlas-numbers span {
  display: block;
}

.atlas-numbers strong {
  font: 400 34px/1 var(--serif);
}

.atlas-numbers span {
  margin-top: 9px;
  color: var(--ink-soft);
  font-size: 10px;
}

.stage-route {
  margin-top: 30px;
  padding: 18px;
  border-left: 3px solid var(--coral);
  background: var(--paper);
  color: var(--ink-soft);
  font-size: 13px;
}

.feature-blueprint {
  border-top: 1px solid var(--line);
}

.feature-table {
  border-top: 1px solid var(--line);
}

.feature-table > div {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 30px;
  padding: 22px 0;
  border-bottom: 1px solid var(--line);
}

.feature-table span {
  color: var(--ink-soft);
}

.chagas-overview {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  align-items: start;
  gap: 20px;
}

.chagas-source-card {
  padding: clamp(36px, 5vw, 70px);
  background: var(--white);
}

.chagas-source-card h2 {
  margin-top: 20px;
}

.chagas-source-card > div:first-child p {
  max-width: 740px;
  color: var(--ink-soft);
}

.chagas-numbers {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 40px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.chagas-numbers > div {
  min-height: 120px;
  padding: 20px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.chagas-numbers strong,
.chagas-numbers span {
  display: block;
}

.chagas-numbers strong {
  font: 400 27px/1 var(--serif);
}

.chagas-numbers span {
  margin-top: 10px;
  color: var(--ink-soft);
  font-size: 10px;
}

.source-links {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 26px;
}

.licence-alert {
  display: flex;
  gap: 18px;
  padding: 28px;
  border-top: 4px solid var(--amber);
  background: #fbf0d6;
}

.licence-alert > span {
  display: grid;
  width: 28px;
  height: 28px;
  border: 1px solid var(--ink);
  border-radius: 50%;
  flex: 0 0 auto;
  font-weight: 800;
  place-items: center;
}

.licence-alert h3 {
  margin: 1px 0 8px;
  font: 400 20px/1.2 var(--serif);
}

.licence-alert p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 12px;
}

.host-fields,
.separation-table {
  border-top: 1px solid var(--line);
}

.evidence-types {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.evidence-types article {
  min-height: 240px;
  padding: 32px;
  border: 1px solid var(--line);
  border-right: 0;
  background: var(--white);
}

.evidence-types article:last-child {
  border-right: 1px solid var(--line);
}

.evidence-types article > span {
  color: var(--coral);
  font: 26px/1 var(--serif);
}

.evidence-types h3 {
  margin: 52px 0 12px;
  font: 400 22px/1.2 var(--serif);
}

.evidence-types p {
  color: var(--ink-soft);
  font-size: 13px;
}

.workflow-line {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.workflow-line > div {
  min-height: 190px;
  padding: 24px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.workflow-line span,
.workflow-line strong,
.workflow-line small {
  display: block;
}

.workflow-line span {
  color: var(--coral);
  font: 24px/1 var(--serif);
}

.workflow-line strong {
  margin-top: 56px;
}

.workflow-line small {
  margin-top: 8px;
  color: var(--ink-soft);
}

.method-columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.method-columns article {
  padding: 48px;
}

.method-columns article + article {
  border-left: 1px solid var(--line);
}

.method-columns h2 {
  margin: 0;
  font: 400 35px/1.2 var(--serif);
}

.method-columns ul {
  margin: 32px 0 0;
  padding: 0;
  list-style: none;
}

.method-columns li {
  padding: 13px 0 13px 24px;
  border-top: 1px solid var(--line);
  color: var(--ink-soft);
}

.method-columns li::before {
  display: inline-block;
  width: 24px;
  margin-left: -24px;
  color: var(--teal);
  content: "•";
}

.terminology {
  border-top: 1px solid var(--line);
}

.terminology-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.terminology-grid article {
  min-height: 145px;
  padding: 24px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.terminology-grid span,
.terminology-grid strong,
.terminology-grid small {
  display: block;
}

.terminology-grid span {
  color: var(--teal);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.terminology-grid strong {
  margin-top: 20px;
  font: 400 20px/1.2 var(--serif);
}

.terminology-grid small {
  margin-top: 9px;
  color: var(--ink-soft);
}

.release-policy {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 70px;
  margin-bottom: 110px;
  padding: 54px;
  background: var(--ink);
  color: var(--white);
}

.gene-expression-method {
  border-top: 1px solid var(--line);
}

.method-source-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 24px;
}

.method-source-links a {
  padding: 9px 12px;
  border: 1px solid var(--ink);
  background: #fff;
  font-size: 10px;
  font-weight: 800;
}

.method-source-links a:first-child {
  background: var(--ink);
  color: #fff;
}

.release-policy h2 {
  margin: 0;
  font: 400 37px/1.15 var(--serif);
}

.release-policy > p {
  margin: 35px 0 0;
  color: #c7d9d5;
}

.site-footer {
  padding: 70px 0;
  background: #0b2523;
  color: #d9e8e4;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr repeat(3, 1fr);
  width: min(1440px, calc(100% - 64px));
  margin: 0 auto;
  gap: 60px;
}

.footer-brand {
  font: 400 32px/1 var(--serif);
}

.site-footer h3 {
  margin: 0 0 16px;
  color: #89ada5;
  font-size: 10px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.site-footer p,
.site-footer a {
  display: block;
  max-width: 410px;
  margin: 0 0 10px;
  color: #a9c0bb;
  font-size: 11px;
}

.footer-institution-strip {
  display: grid;
  grid-template-columns: 150px minmax(0, 1fr) auto;
  width: min(1440px, calc(100% - 64px));
  align-items: center;
  gap: 34px;
  margin: 42px auto 0;
  padding-top: 30px;
  border-top: 1px solid rgba(217, 232, 228, 0.2);
}

.site-footer .footer-institution-mark {
  display: grid;
  width: 150px;
  max-width: none;
  min-height: 116px;
  margin: 0;
  padding: 8px;
  background: #fff;
  box-shadow: inset 0 3px #006537;
  place-items: center;
}

.footer-institution-mark img {
  display: block;
  width: 100%;
  height: auto;
}

.footer-institution-copy strong {
  display: block;
  margin-bottom: 7px;
  color: #f3f8f6;
  font: 400 20px/1.2 var(--serif);
}

.site-footer .footer-institution-copy p {
  max-width: 720px;
  margin-bottom: 7px;
}

.footer-institution-copy small {
  display: block;
  max-width: 820px;
  color: #89ada5;
  font-size: 9px;
  line-height: 1.55;
}

.footer-institution-links {
  display: grid;
  justify-items: end;
  gap: 7px;
}

.site-footer .footer-institution-links a {
  max-width: none;
  margin: 0;
  color: #d9e8e4;
  font-size: 9px;
  font-weight: 800;
  text-decoration: underline;
  text-decoration-color: rgba(217, 232, 228, 0.34);
  text-underline-offset: 3px;
}

@media (max-width: 1120px) {
  .header-inner {
    grid-template-columns: 1fr auto;
  }

  .main-nav {
    display: none;
  }

  .hero {
    grid-template-columns: 1fr 0.8fr;
    gap: 42px;
  }

  .hero h1 {
    font-size: clamp(50px, 7vw, 72px);
  }

  .species-live {
    padding-right: 90px;
  }

  .chagas-overview {
    grid-template-columns: 1fr;
  }

  .licence-alert {
    max-width: none;
  }
}

@media (max-width: 820px) {
  .header-inner,
  .hero,
  .section,
  .page-hero,
  .footer-grid,
  .footer-institution-strip {
    width: min(100% - 36px, 1440px);
  }

  .header-inner {
    min-height: 72px;
  }

  .brand small,
  .verified-label {
    display: none;
  }

  .hero {
    grid-template-columns: 1fr;
    padding-top: 68px;
  }

  .hero-figure {
    max-width: 580px;
  }

  .metrics {
    grid-template-columns: repeat(2, 1fr);
  }

  .metrics > div:nth-child(2) {
    border-right: 0;
  }

  .metrics > div:nth-child(-n + 2) {
    border-bottom: 1px solid var(--line);
  }

  .section {
    padding: 80px 0;
  }

  .section-heading,
  .host-panel,
  .release-policy {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .species-grid,
  .atlas-grid,
  .method-columns {
    grid-template-columns: 1fr;
  }

  .gap-card {
    grid-column: auto;
  }

  .lifecycle-track,
  .field-grid,
  .chagas-numbers,
  .workflow-line,
  .terminology-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .trust-grid,
  .evidence-types {
    grid-template-columns: 1fr;
  }

  .evidence-types article {
    border-right: 1px solid var(--line);
    border-bottom: 0;
  }

  .evidence-types article:last-child {
    border-bottom: 1px solid var(--line);
  }

  .catalogue-tools {
    grid-template-columns: 1fr;
  }

  .dataset-card {
    grid-template-columns: 64px minmax(0, 1fr);
  }

  .dataset-status {
    grid-column: 2;
    padding: 15px 0 0;
    border-top: 1px solid var(--line);
    border-left: 0;
  }

  .provenance-banner {
    grid-template-columns: 1fr;
  }

  .method-columns article + article {
    border-top: 1px solid var(--line);
    border-left: 0;
  }

  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .footer-institution-strip {
    grid-template-columns: 130px minmax(0, 1fr);
  }

  .site-footer .footer-institution-mark {
    width: 130px;
  }

  .footer-institution-links {
    grid-column: 2;
    justify-items: start;
  }
}

@media (max-width: 540px) {
  .brand strong {
    font-size: 17px;
  }

  .header-actions {
    gap: 7px;
  }

  .hero h1,
  .page-hero h1 {
    font-size: 46px;
  }

  .hero-figure figcaption {
    display: block;
  }

  .hero-figure figcaption a {
    display: block;
    margin-top: 6px;
    text-align: left;
  }

  .metrics > div {
    min-height: 110px;
    padding: 18px 10px;
    flex-direction: column;
  }

  .metrics strong {
    font-size: 31px;
  }

  .species-card,
  .atlas-card {
    padding: 28px;
  }

  .species-live {
    padding-right: 28px;
  }

  .species-live::after {
    display: none;
  }

  .lifecycle-track,
  .field-grid,
  .chagas-numbers,
  .workflow-line,
  .terminology-grid,
  .host-stats {
    grid-template-columns: 1fr;
  }

  .catalogue-tools .segmented {
    overflow-x: auto;
  }

  .dataset-card {
    grid-template-columns: 1fr;
  }

  .dataset-status {
    grid-column: 1;
  }

  .feature-table > div {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
  }

  .footer-institution-strip {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .site-footer .footer-institution-mark {
    width: 128px;
  }

  .footer-institution-links {
    grid-column: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  *,
  *::before,
  *::after {
    transition-duration: 0.01ms !important;
  }
}

/* 2026 atlas interface: reference-site information architecture, original styling */
:root {
  --ink: #171719;
  --ink-soft: #5e5b61;
  --paper: #f7f6f3;
  --white: #ffffff;
  --mint: #e6eeee;
  --teal: #287f80;
  --teal-dark: #1c5f61;
  --coral: #c53a32;
  --amber: #d59b2d;
  --line: #d8d4d8;
  --plum: #918996;
  --plum-light: #ece8ed;
}

.site-header {
  border-bottom-color: #bdb9bd;
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(10px);
}

.header-inner {
  grid-template-columns: minmax(350px, 1fr) auto minmax(210px, auto);
  width: min(1200px, calc(100% - 56px));
  min-height: 112px;
}

.brand {
  gap: 18px;
}

.brand-mark {
  position: relative;
  width: 74px;
  height: 74px;
  border: 1px solid #171719;
  background: #fff;
}

.brand-mark::before,
.brand-mark::after {
  position: absolute;
  width: 54px;
  height: 20px;
  border: 1px solid #918996;
  border-radius: 50%;
  content: "";
  transform: rotate(28deg);
}

.brand-mark::after {
  transform: rotate(-28deg);
}

.brand-mark i {
  position: absolute;
  z-index: 1;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--coral);
}

.brand-mark i:nth-child(1) {
  top: 14px;
  left: 35px;
}

.brand-mark i:nth-child(2) {
  top: 31px;
  left: 15px;
}

.brand-mark i:nth-child(3) {
  top: 36px;
  right: 14px;
}

.brand-mark i:nth-child(4) {
  bottom: 13px;
  left: 29px;
}

.brand-mark i:nth-child(5) {
  right: 26px;
  bottom: 18px;
  background: var(--teal);
}

.brand strong {
  font-family: Arial, "PingFang SC", sans-serif;
  font-size: clamp(28px, 3vw, 42px);
  font-weight: 800;
  letter-spacing: -0.045em;
}

.brand strong b {
  color: var(--coral);
}

.brand small {
  margin-top: 2px;
  font-size: 10px;
  letter-spacing: 0.08em;
}

.main-nav {
  gap: 0;
}

.main-nav a {
  padding: 0 13px;
  border-right: 0;
  font-size: 13px;
}

.main-nav a + a::before {
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 14px;
  background: var(--ink);
  content: "";
  opacity: 0.72;
  transform: translateY(-50%);
}

.main-nav a::after {
  background: var(--coral);
}

.verified-label {
  font-size: 10px;
}

.home-intro {
  width: min(1200px, calc(100% - 56px));
  margin: 0 auto;
  padding: 62px 0 24px;
}

.home-intro h1 {
  max-width: 960px;
  margin: 0;
  font-family: Arial, "PingFang SC", sans-serif;
  font-size: clamp(42px, 5.6vw, 72px);
  letter-spacing: -0.055em;
  line-height: 1.02;
}

.home-intro > p:last-child {
  max-width: 850px;
  margin: 20px 0 0;
  color: var(--ink-soft);
  font-size: 16px;
}

.home-explorer.section {
  width: min(1200px, calc(100% - 56px));
  padding: 28px 0 64px;
}

.coverage-explorer {
  display: grid;
  grid-template-columns: 310px minmax(0, 1fr);
  min-height: 600px;
  border-top: 1px solid var(--ink);
  border-bottom: 1px solid var(--ink);
  background: #fff;
}

.coverage-species {
  padding: 28px 28px 30px 0;
}

.coverage-species h2 {
  margin: 0 0 26px;
  font-size: 25px;
  line-height: 1.05;
  text-align: center;
  text-transform: uppercase;
}

.coverage-species button {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  width: 100%;
  min-height: 64px;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 17px;
  border: 2px solid #171719;
  border-radius: 14px;
  background: #fff;
  color: #171719;
  cursor: pointer;
  text-align: left;
}

.coverage-species button i {
  font-family: Georgia, serif;
  font-size: 15px;
  font-weight: 700;
}

.coverage-species button span {
  grid-row: 2;
  color: var(--ink-soft);
  font-size: 10px;
}

.coverage-species button strong {
  grid-row: 1 / 3;
  grid-column: 2;
  font-size: 24px;
}

.coverage-species button.active {
  border-color: var(--coral);
  background: var(--coral);
  color: #fff;
}

.coverage-species button.active span {
  color: #fff;
  opacity: 0.78;
}

.coverage-species button.disabled {
  border-width: 1px;
  border-color: #c9c5ca;
  border-radius: 7px;
  color: #888389;
  cursor: not-allowed;
}

.coverage-species > small {
  display: block;
  margin-top: 18px;
  color: var(--ink-soft);
  font-size: 10px;
  line-height: 1.55;
}

.coverage-map {
  position: relative;
  overflow: hidden;
  padding: 34px 38px 26px;
  background: var(--plum);
  color: #fff;
}

.coverage-map::before {
  position: absolute;
  top: -220px;
  right: -120px;
  width: 520px;
  height: 520px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  content: "";
}

.coverage-map-heading {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

.coverage-map-heading > div:first-child > span {
  color: #fff;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.18em;
}

.coverage-map-heading h2 {
  margin: 6px 0 0;
  font: 400 clamp(27px, 3vw, 42px)/1.08 Georgia, serif;
}

.coverage-map-heading p {
  margin: 6px 0 0;
  color: #e9e4ea;
  font-size: 12px;
}

.coverage-map-heading > div:last-child {
  text-align: right;
}

.coverage-map-heading > div:last-child strong,
.coverage-map-heading > div:last-child small {
  display: block;
}

.coverage-map-heading > div:last-child strong {
  font: 400 36px/1 Georgia, serif;
}

.coverage-map-heading > div:last-child small {
  margin-top: 7px;
  color: #e9e4ea;
}

.stage-orbit {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 54px 40px;
  margin-top: 58px;
}

.orbit-line {
  position: absolute;
  z-index: -1;
  top: 38px;
  right: 14%;
  bottom: 38px;
  left: 14%;
  border: 2px dashed rgba(255, 255, 255, 0.38);
  border-radius: 50%;
}

.stage-node {
  display: grid;
  justify-items: center;
  text-align: center;
}

.stage-node > span {
  display: grid;
  width: 64px;
  height: 64px;
  border: 2px solid #fff;
  border-radius: 50%;
  background: #fff;
  color: var(--plum);
  font: 700 17px/1 Arial, sans-serif;
  place-items: center;
}

.stage-node > span.not-covered {
  border-style: dashed;
  background: var(--plum);
  color: #fff;
}

.stage-node strong {
  margin-top: 12px;
  font: italic 700 14px/1.2 Georgia, serif;
}

.stage-node small {
  margin-top: 3px;
  color: #e9e4ea;
  font-size: 9px;
}

.stage-node em {
  margin-top: 5px;
  color: #fff3ad;
  font-size: 8px;
  font-style: normal;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.coverage-map footer {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin-top: 44px;
  padding-top: 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.28);
}

.coverage-map footer > div {
  display: flex;
  max-width: 530px;
  align-items: flex-start;
  gap: 9px;
}

.coverage-map footer p {
  margin: 0;
  color: #eee9ef;
  font-size: 10px;
}

.coverage-dot {
  width: 9px;
  height: 9px;
  flex: 0 0 auto;
  margin-top: 3px;
  border-radius: 50%;
  background: #fff3ad;
}

.coverage-map footer a {
  flex: 0 0 auto;
  padding: 10px 15px;
  border: 1px solid #fff;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 800;
}

.coverage-citation {
  margin: 12px 0 0;
  color: #ded8e0;
  font-size: 9px;
  text-align: right;
}

.metrics {
  background: #fff;
}

.metrics strong {
  color: var(--coral);
  font-family: Arial, sans-serif;
  font-size: 32px;
  font-weight: 800;
}

.section {
  width: min(1200px, calc(100% - 56px));
}

.compact-section {
  padding-top: 72px;
  padding-bottom: 72px;
}

.live-atlas-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.live-atlas-grid article {
  min-height: 245px;
  padding: 30px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.live-atlas-grid article > span {
  color: var(--coral);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.live-atlas-grid h3 {
  margin: 35px 0 12px;
  font: 400 26px/1.2 Georgia, serif;
}

.live-atlas-grid p {
  max-width: 500px;
  color: var(--ink-soft);
  font-size: 13px;
}

.live-atlas-grid a {
  display: inline-block;
  margin-top: 16px;
  border-bottom: 1px solid;
  font-size: 12px;
  font-weight: 800;
}

.live-atlas-grid .gap-summary {
  grid-column: 1 / -1;
  min-height: 180px;
  background: var(--plum-light);
}

.gap-summary h3 {
  margin-top: 18px;
}

.host-panel {
  background: #6f6875;
}

.page-hero {
  width: min(1200px, calc(100% - 56px));
}

.page-hero h1 {
  font-family: Arial, "PingFang SC", sans-serif;
  font-size: clamp(42px, 5vw, 70px);
  font-weight: 800;
  letter-spacing: -0.055em;
  line-height: 1.03;
}

.page-hero > h1 + p {
  max-width: 800px;
  margin-top: 24px;
  font-size: 16px;
  line-height: 1.7;
}

.atlas-page-hero {
  padding-bottom: 58px;
}

.atlas-section {
  padding-top: 36px;
}

.atlas-shell {
  overflow: hidden;
  border: 1px solid #bcb7bd;
  background: #fff;
}

.atlas-species-tabs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background: #f1eef2;
}

.atlas-species-tabs button {
  display: grid;
  grid-template-columns: minmax(82px, auto) minmax(0, 1fr);
  min-height: 82px;
  align-items: center;
  column-gap: 12px;
  padding: 12px 22px;
  border: 0;
  border-right: 1px solid #bcb7bd;
  border-bottom: 1px solid #bcb7bd;
  background: transparent;
  color: var(--ink);
  cursor: pointer;
  text-align: left;
}

.atlas-species-tabs button:last-child {
  grid-column: 1 / -1;
  border-right: 0;
}

.atlas-species-tabs button > span {
  grid-row: 1 / 3;
  display: inline-flex;
  width: fit-content;
  min-width: 54px;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  padding: 7px 9px;
  border: 1px solid currentColor;
  border-radius: 3px;
  color: var(--coral);
  font: italic 700 13px/1.08 Georgia, serif;
  overflow-wrap: anywhere;
  text-align: center;
}

.atlas-species-tabs button i {
  font: italic 700 16px/1.2 Georgia, serif;
}

.atlas-species-tabs button small {
  color: var(--ink-soft);
}

.atlas-species-tabs button.active {
  background: #fff;
  box-shadow: inset 0 -4px 0 var(--coral);
}

.atlas-section-tabs {
  display: flex;
  padding: 0 22px;
  border-bottom: 1px solid var(--line);
  gap: 4px;
}

.atlas-section-tabs button {
  padding: 15px 18px 12px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 800;
}

.atlas-section-tabs button.active {
  border-bottom-color: var(--coral);
  color: var(--coral);
}

.atlas-view-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 25px;
  padding: 20px 24px;
  border-bottom: 1px solid var(--line);
}

.view-switch {
  display: flex;
  align-items: center;
  gap: 4px;
}

.view-switch button {
  min-width: 100px;
  padding: 9px 14px;
  border: 1px solid var(--ink);
  background: #fff;
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
}

.view-switch button.active {
  background: var(--ink);
  color: #fff;
}

.view-switch button:disabled {
  border-color: #ccc8cd;
  color: #aaa5ab;
  cursor: not-allowed;
}

.view-switch small {
  max-width: 240px;
  margin-left: 8px;
  color: #8a858b;
  font-size: 9px;
}

.atlas-dataset-line {
  color: var(--ink-soft);
  font-size: 10px;
  text-align: right;
}

.atlas-dataset-line span {
  display: block;
}

.gene-search-panel {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(420px, 1.45fr);
  align-items: end;
  gap: 18px;
  padding: 18px 24px;
  border-bottom: 1px solid var(--line);
  background: #f7f5f7;
}

.gene-search-box {
  position: relative;
  display: grid;
  gap: 6px;
}

.gene-search-box > span,
.marker-gene-buttons > span {
  color: var(--ink-soft);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.gene-search-box input {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #9f99a1;
  border-radius: 0;
  background: #fff;
  color: var(--ink);
  font-size: 12px;
}

.gene-search-box input:focus {
  border-color: var(--coral);
  outline: 2px solid rgba(197, 58, 50, 0.12);
}

.gene-suggestions {
  position: absolute;
  z-index: 12;
  top: calc(100% + 4px);
  right: 0;
  left: 0;
  max-height: 360px;
  overflow-y: auto;
  border: 1px solid #9f99a1;
  background: #fff;
  box-shadow: 0 16px 40px rgba(32, 28, 34, 0.14);
}

.gene-suggestions button {
  display: grid;
  width: 100%;
  grid-template-columns: minmax(105px, auto) minmax(0, 1fr);
  gap: 2px 10px;
  padding: 10px 12px;
  border: 0;
  border-bottom: 1px solid var(--line);
  background: #fff;
  color: var(--ink);
  cursor: pointer;
  text-align: left;
}

.gene-suggestions button:hover,
.gene-suggestions button[aria-selected="true"] {
  background: #f1e9e8;
}

.gene-suggestions button strong {
  grid-row: 1 / 3;
  font-family: Georgia, serif;
  font-size: 11px;
}

.gene-suggestions button span {
  overflow: hidden;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gene-suggestions button small {
  overflow: hidden;
  color: var(--ink-soft);
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.marker-gene-buttons {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.marker-gene-buttons > span {
  width: 100%;
}

.marker-gene-buttons button {
  display: grid;
  min-width: 90px;
  flex: 1 1 90px;
  gap: 1px;
  padding: 6px 8px;
  border: 1px solid #bcb8bd;
  background: #fff;
  color: var(--ink);
  cursor: pointer;
  font-size: 10px;
  font-weight: 800;
  text-align: left;
}

.marker-gene-buttons button small {
  color: var(--ink-soft);
  font-size: 7px;
  font-weight: 400;
}

.marker-gene-buttons button.active {
  border-color: var(--coral);
  background: var(--coral);
  color: #fff;
}

.marker-gene-buttons button.active small {
  color: rgba(255, 255, 255, 0.78);
}

.marker-gene-buttons button:disabled {
  cursor: wait;
  opacity: 0.45;
}

.paper-marker-panel {
  grid-column: 1 / -1;
  margin-top: 4px;
  padding-top: 16px;
  border-top: 1px solid var(--line);
}

.paper-marker-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 12px;
}

.paper-marker-panel > header strong {
  font: 700 15px/1.2 Georgia, serif;
}

.paper-marker-panel > header p {
  max-width: 760px;
  margin: 5px 0 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.paper-marker-panel > header a {
  flex: 0 0 auto;
  border-bottom: 1px solid;
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
}

.paper-marker-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.paper-marker-grid article {
  display: grid;
  min-width: 0;
  align-content: space-between;
  gap: 12px;
  padding: 12px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.paper-marker-grid article > div:first-child > span {
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.paper-marker-grid h3 {
  margin: 5px 0;
  font: 700 13px/1.2 Georgia, serif;
}

.paper-marker-grid p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.paper-marker-genes {
  display: grid;
  gap: 5px;
}

.paper-marker-genes button {
  display: grid;
  gap: 2px;
  padding: 7px;
  border: 1px solid #cbc5ca;
  background: #faf9f7;
  color: var(--ink);
  cursor: pointer;
  text-align: left;
}

.paper-marker-genes button.active {
  border-color: var(--coral);
  background: #f7e8e6;
}

.paper-marker-genes button:disabled {
  cursor: wait;
  opacity: 0.45;
}

.paper-marker-genes code {
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
}

.paper-marker-genes span {
  overflow: hidden;
  font-size: 8px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gene-index-error {
  grid-column: 1 / -1;
  margin: 0;
  color: #9b302a;
  font-size: 10px;
}

.atlas-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
}

.atlas-workspace.filters-collapsed {
  grid-template-columns: minmax(0, 1fr) 76px;
}

.plot-column {
  min-width: 0;
  padding: 18px;
  border-right: 1px solid var(--line);
}

.plot-controls {
  display: grid;
  grid-template-columns: auto minmax(180px, 1fr) minmax(180px, 0.7fr);
  gap: 16px;
  margin-bottom: 12px;
}

.plot-controls label,
.control-group {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
}

.plot-controls label > span,
.control-group > span {
  flex: 0 0 auto;
  color: var(--ink-soft);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.control-group button,
.plot-toolbar button,
.download-actions button,
.record-links button {
  padding: 7px 9px;
  border: 1px solid #bcb8bd;
  background: #fff;
  color: var(--ink);
  cursor: pointer;
  font-size: 9px;
  font-weight: 800;
}

.control-group button.active,
.plot-toolbar button.active {
  border-color: var(--coral);
  background: var(--coral);
  color: #fff;
}

.plot-controls select {
  min-width: 0;
  width: 100%;
  height: 31px;
  border: 1px solid #bcb8bd;
  background: #fff;
  color: var(--ink);
  font-size: 10px;
}

.expression-control {
  display: grid;
  min-width: 0;
  align-content: center;
  gap: 2px;
}

.expression-control > span {
  color: var(--ink-soft);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.expression-control strong {
  overflow: hidden;
  font-family: Georgia, serif;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.point-slider input {
  min-width: 80px;
  width: 100%;
  accent-color: var(--coral);
}

.plot-toolbar {
  display: flex;
  overflow-x: auto;
  gap: 5px;
  padding: 7px;
  border: 1px solid var(--line);
  border-bottom: 0;
  background: #f7f5f7;
}

.plot-toolbar > span {
  width: 1px;
  flex: 0 0 auto;
  margin: 2px 4px;
  background: var(--line);
}

.plot-frame {
  position: relative;
  overflow: hidden;
  width: 100%;
  border: 1px solid var(--line);
  background: #fff;
}

.plot-hover-hint {
  display: flex;
  align-items: center;
  gap: 7px;
  margin: 0;
  padding: 8px 10px;
  border: 1px solid var(--line);
  border-bottom: 0;
  background: #fffdf7;
  color: var(--ink-soft);
  font-size: 9px;
}

.plot-hover-hint span {
  color: var(--coral);
  font-size: 14px;
  line-height: 1;
}

.plot-frame canvas {
  display: block;
  max-width: 100%;
  cursor: grab;
  touch-action: none;
}

.plot-frame canvas[data-tool="point"] {
  cursor: crosshair;
}

.plot-frame canvas:active {
  cursor: grabbing;
}

.plot-frame canvas[data-tool="point"]:active {
  cursor: crosshair;
}

.plot-hover-readout {
  display: grid;
  grid-template-columns: minmax(180px, 0.85fr) minmax(0, 3.15fr);
  min-height: 52px;
  border: 1px solid var(--line);
  border-top: 3px solid var(--teal-dark);
  background: #f7faf8;
}

.plot-hover-readout:not(.visible) {
  display: flex;
  align-items: center;
  padding: 0 14px;
  color: var(--ink-soft);
  font-size: 8px;
}

.hover-readout-id {
  min-width: 0;
  padding: 9px 12px;
  border-right: 1px solid var(--line);
}

.hover-readout-id > p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.hover-readout-id > strong {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  font: 700 10px/1.35 Georgia, serif;
  overflow-wrap: anywhere;
}

.plot-hover-readout dl {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  align-items: stretch;
  margin: 0;
}

.plot-hover-readout dl > div {
  display: grid;
  min-width: 120px;
  padding: 9px 12px;
  border-right: 1px dotted #d5cfd4;
}

.plot-hover-readout dt,
.plot-hover-readout dd {
  margin: 0;
  font-size: 8px;
  line-height: 1.3;
}

.plot-hover-readout dt {
  color: var(--ink-soft);
}

.plot-hover-readout dd {
  margin-top: 3px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.plot-hover-readout .hover-expression {
  min-width: 170px;
  background: #fbf1ed;
  color: #8f272e;
}

.plot-hover-readout.gene-hover-readout {
  grid-template-columns: minmax(210px, 1fr) minmax(0, 2fr);
}

.gene-expression-summary {
  display: grid;
  grid-template-columns: 1.35fr repeat(3, 1fr);
  margin: 9px 0;
  border: 1px solid var(--line);
  background: #fffef9;
}

.gene-expression-summary > div {
  min-width: 0;
  padding: 10px 12px;
  border-right: 1px solid var(--line);
}

.gene-expression-summary > div:last-child {
  border-right: 0;
}

.gene-expression-summary span,
.gene-expression-summary strong {
  display: block;
  overflow-wrap: anywhere;
}

.gene-expression-summary span {
  color: var(--ink-soft);
  font-size: 8px;
}

.gene-expression-summary strong {
  margin-top: 3px;
  font: 700 12px/1.25 Georgia, serif;
}

.selection-box {
  position: absolute;
  border: 1px solid var(--coral);
  background: rgba(197, 58, 50, 0.12);
  pointer-events: none;
}

.selection-lasso {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.selection-lasso polyline {
  fill: rgba(197, 58, 50, 0.1);
  stroke: var(--coral);
  stroke-width: 1.5;
}

.plot-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  padding: 11px 2px;
}

.plot-counts {
  display: flex;
  gap: 15px;
  color: var(--ink-soft);
  font-size: 10px;
}

.plot-counts strong {
  color: var(--ink);
}

.download-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
}

.download-actions button:disabled,
.record-links button:disabled {
  color: #aaa5ab;
  cursor: not-allowed;
}

.selected-cell-detail,
.selected-set-detail {
  margin: 6px 0 16px;
  border: 1px solid var(--line);
  background: #fffef9;
}

.selected-cell-detail > header,
.selected-set-detail > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--line);
  background: #f8f2e8;
}

.selected-cell-detail header p,
.selected-set-detail header p {
  margin: 0 0 4px;
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.selected-cell-detail header h3,
.selected-set-detail header h3 {
  margin: 0;
  font: 700 17px/1.25 Georgia, serif;
  overflow-wrap: anywhere;
}

.selected-cell-detail header small {
  display: block;
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 9px;
}

.selected-cell-detail header > span,
.selected-set-detail header > span {
  flex: 0 0 auto;
  padding: 5px 8px;
  border: 1px solid #b9cfc5;
  background: #edf6f1;
  color: var(--teal-dark);
  font-size: 8px;
  font-weight: 800;
}

.selected-cell-detail-grid {
  display: grid;
  grid-template-columns: 1.15fr 1fr 0.9fr 1.25fr;
}

.selected-cell-detail-grid > section,
.selected-cell-detail-grid > aside {
  min-width: 0;
  padding: 17px 18px;
  border-right: 1px solid var(--line);
}

.selected-cell-detail-grid > :last-child {
  border-right: 0;
}

.selected-cell-detail-grid h4,
.selected-set-grid h4 {
  margin: 0 0 10px;
  color: var(--ink-soft);
  font-size: 8px;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.selected-cell-detail-grid dl {
  display: grid;
  gap: 0;
  margin: 0;
}

.selected-cell-detail-grid dl > div {
  display: grid;
  grid-template-columns: minmax(78px, 0.9fr) minmax(0, 1.1fr);
  gap: 8px;
  padding: 5px 0;
  border-top: 1px dotted #d9d4cf;
}

.selected-cell-detail-grid dt,
.selected-cell-detail-grid dd {
  margin: 0;
  font-size: 8px;
  line-height: 1.35;
}

.selected-cell-detail-grid dt,
.selected-cell-detail-grid section > p,
.selected-cell-detail-grid aside > p {
  color: var(--ink-soft);
}

.selected-cell-detail-grid dd {
  font-weight: 800;
  overflow-wrap: anywhere;
  text-align: right;
}

.selected-cell-detail-grid .detail-expression {
  border-top-color: var(--coral);
  color: #8f272e;
}

.selected-cell-detail-grid .selected-gene-result {
  background: #fbf1ed;
}

.selected-gene-result > strong,
.selected-gene-result > span {
  display: block;
}

.selected-gene-result > strong {
  color: #8f272e;
  font: 700 32px/1 Georgia, serif;
}

.selected-gene-result > span {
  margin: 5px 0 14px;
  color: var(--ink-soft);
  font-size: 8px;
}

.selected-cell-detail-grid section > p,
.selected-cell-detail-grid aside > p {
  margin: 11px 0 0;
  font-size: 8px;
  line-height: 1.5;
}

.selected-cell-detail-grid aside > strong {
  display: block;
  font: 700 10px/1.45 Georgia, serif;
}

.selected-cell-detail-grid aside > div {
  display: grid;
  gap: 5px;
  margin-top: 13px;
}

.selected-cell-detail-grid aside a {
  width: fit-content;
  border-bottom: 1px solid var(--coral);
  color: var(--ink);
  font-size: 8px;
  font-weight: 800;
}

.selected-set-detail {
  padding-bottom: 18px;
}

.selected-set-detail > p {
  max-width: 780px;
  margin: 14px 20px 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.selected-set-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  padding: 16px 20px 0;
}

.selected-expression-summary > div {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 6px 0;
  border-top: 1px dotted #d9d4cf;
  font-size: 9px;
}

.selected-expression-summary span {
  color: var(--ink-soft);
}

.selected-expression-summary strong {
  color: #8f272e;
}

.selected-composition {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.selected-composition span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 7px;
  border: 1px solid var(--line);
  background: #fff;
  font-size: 8px;
}

.selected-composition i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.selected-composition strong {
  color: var(--coral);
}

.selected-id-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px 10px;
}

.selected-id-list code {
  overflow: hidden;
  font-size: 8px;
  overflow-wrap: anywhere;
}

.selected-id-list small {
  color: var(--ink-soft);
  font-size: 8px;
}

.plot-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 15px;
  padding: 12px 0 3px;
  border-top: 1px solid var(--line);
}

.plot-legend span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 9px;
}

.plot-legend i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.plot-source-note {
  margin: 12px 0 0;
  color: #777278;
  font-size: 9px;
}

.expression-status {
  padding: 8px 10px;
  border: 1px solid #d9c8a4;
  border-bottom: 0;
  background: #fff8e8;
  color: #6c5627;
  font-size: 9px;
}

.expression-status.error {
  border-color: #e2b9b6;
  background: #fff0ef;
  color: #9b302a;
}

.expression-legend {
  display: grid;
  grid-template-columns: auto minmax(140px, 1fr) auto auto;
  align-items: center;
  gap: 8px;
  padding: 12px 0 4px;
  border-top: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 9px;
}

.expression-legend i {
  height: 8px;
  border: 1px solid rgba(116, 51, 42, 0.25);
  background: linear-gradient(90deg, #f6db96, #97252b);
}

.expression-legend.scaled i {
  border-color: rgba(52, 103, 147, 0.28);
  background: linear-gradient(90deg, #346793, #f4f1e8 50%, #a63030);
}

.expression-distribution {
  margin-top: 12px;
  padding: 16px;
  border: 1px solid var(--line);
  background: #faf9f5;
}

.expression-distribution-heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 18px;
}

.expression-distribution-heading h3 {
  margin: 0;
  font: 700 13px/1.2 Georgia, serif;
}

.expression-distribution-heading span {
  color: var(--ink-soft);
  font-size: 8px;
  text-align: right;
}

.expression-stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 13px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.expression-stat-grid > div {
  min-width: 0;
  padding: 9px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.expression-stat-grid span,
.expression-stat-grid strong {
  display: block;
}

.expression-stat-grid span {
  min-height: 25px;
  color: var(--ink-soft);
  font-size: 8px;
}

.expression-stat-grid strong {
  margin-top: 4px;
  font: 400 17px/1 Georgia, serif;
}

.expression-histogram {
  display: flex;
  height: 88px;
  align-items: flex-end;
  gap: 3px;
  margin-top: 15px;
  border-bottom: 1px solid #938d93;
}

.expression-histogram span {
  min-height: 3px;
  flex: 1;
  background: linear-gradient(#b84745, #8f272e);
}

.histogram-axis {
  display: flex;
  justify-content: space-between;
  padding-top: 4px;
  color: var(--ink-soft);
  font-size: 8px;
}

.gene-comparison-panel {
  margin-top: 14px;
  border: 1px solid var(--line);
  border-top: 4px solid var(--teal-dark);
  background: #fffef9;
}

.gene-comparison-panel > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 17px 18px;
  border-bottom: 1px solid var(--line);
  background: #f3f7f4;
}

.gene-comparison-panel > header p,
.gene-comparison-panel > header h3 {
  margin: 0;
}

.gene-comparison-panel > header p {
  color: var(--teal-dark);
  font: 700 15px/1.2 Georgia, serif;
}

.gene-comparison-panel > header h3 {
  max-width: 610px;
  margin-top: 5px;
  color: var(--ink-soft);
  font: 400 9px/1.45 Arial, sans-serif;
}

.comparison-actions,
.comparison-scope,
.comparison-gene-chips {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.comparison-actions {
  flex: 0 0 auto;
  justify-content: flex-end;
}

.comparison-actions button,
.comparison-scope button {
  min-height: 30px;
  padding: 6px 9px;
  border: 1px solid #aaa4aa;
  background: #fff;
  color: var(--ink);
  font-size: 8px;
  font-weight: 800;
}

.comparison-actions button:disabled,
.comparison-scope button:disabled {
  color: #aaa5ab;
  cursor: not-allowed;
}

.comparison-gene-chips {
  padding: 12px 18px 5px;
}

.comparison-gene-chips > span {
  display: grid;
  grid-template-columns: auto auto 20px;
  align-items: center;
  gap: 6px;
  padding: 5px 5px 5px 8px;
  border: 1px solid #b9cfc5;
  background: #edf6f1;
  font-size: 8px;
}

.comparison-gene-chips code {
  color: var(--ink-soft);
  font-size: 7px;
}

.comparison-gene-chips button {
  display: grid;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #8f272e;
  font-size: 14px;
  place-items: center;
}

.comparison-scope {
  padding: 8px 18px 13px;
  border-bottom: 1px solid var(--line);
}

.comparison-scope > span {
  margin-right: 3px;
  color: var(--ink-soft);
  font-size: 8px;
  font-weight: 800;
}

.comparison-scope button.active {
  border-color: var(--teal-dark);
  background: var(--teal-dark);
  color: #fff;
}

.comparison-status,
.comparison-empty {
  margin: 13px 18px;
  padding: 9px 11px;
  background: #edf6f1;
  color: var(--teal-dark);
  font-size: 9px;
}

.comparison-status.error {
  background: #fff0ef;
  color: #9b302a;
}

.comparison-table-wrap {
  overflow-x: auto;
  padding: 14px 18px 0;
}

.comparison-stat-table {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
  font-size: 8px;
}

.comparison-stat-table th,
.comparison-stat-table td {
  padding: 9px 10px;
  border: 1px solid var(--line);
  text-align: left;
  vertical-align: middle;
}

.comparison-stat-table thead th {
  background: #f2f0ed;
  color: var(--ink-soft);
  font-weight: 800;
}

.comparison-stat-table tbody th {
  min-width: 130px;
  background: #fff;
}

.comparison-stat-table tbody th strong,
.comparison-stat-table tbody th code,
.comparison-stat-table td small {
  display: block;
}

.comparison-stat-table tbody th code,
.comparison-stat-table td small {
  margin-top: 3px;
  color: var(--ink-soft);
  font-size: 7px;
}

.cell-type-comparison {
  padding: 18px;
}

.cell-type-comparison > div:first-child {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 9px;
}

.cell-type-comparison h4,
.cell-type-comparison p {
  margin: 0;
}

.cell-type-comparison h4 {
  font: 700 12px/1.2 Georgia, serif;
}

.cell-type-comparison p {
  color: var(--ink-soft);
  font-size: 8px;
}

.cell-type-comparison-grid {
  overflow-x: auto;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.comparison-grid-row {
  display: grid;
  min-width: 430px;
}

.comparison-grid-row > span,
.comparison-grid-row > strong {
  min-width: 0;
  padding: 8px 9px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.comparison-grid-row > span strong,
.comparison-grid-row > span small {
  display: block;
}

.comparison-grid-row > span small {
  margin-top: 3px;
  color: var(--ink-soft);
  font-size: 7px;
}

.comparison-grid-header > strong,
.comparison-grid-header > span {
  background: #f2f0ed;
  color: var(--ink-soft);
  font-size: 8px;
}

.distribution-explorer,
.comparison-statistics,
.pairwise-comparison,
.sample-audit {
  margin: 0 18px 18px;
  border: 1px solid var(--line);
  background: #faf9f5;
}

.distribution-explorer > header,
.comparison-statistics > header,
.pairwise-comparison > header,
.sample-audit > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 15px 16px;
  border-bottom: 1px solid var(--line);
  background: #f7f4ef;
}

.distribution-explorer h4,
.distribution-explorer p,
.comparison-statistics h4,
.comparison-statistics p,
.pairwise-comparison h4,
.pairwise-comparison p,
.sample-audit h4,
.sample-audit p,
.analysis-export h4,
.analysis-export p {
  margin: 0;
}

.distribution-explorer h4,
.comparison-statistics h4,
.pairwise-comparison h4,
.sample-audit h4,
.analysis-export h4 {
  font: 700 13px/1.2 Georgia, serif;
}

.distribution-explorer header p,
.comparison-statistics header p,
.pairwise-comparison header p,
.sample-audit header p {
  max-width: 610px;
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 8px;
  line-height: 1.45;
}

.distribution-controls {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-end;
  gap: 8px;
}

.distribution-controls label,
.distribution-controls label span {
  display: block;
}

.distribution-controls label span {
  margin-bottom: 4px;
  color: var(--ink-soft);
  font-size: 7px;
  font-weight: 800;
}

.distribution-controls select {
  max-width: 210px;
  height: 31px;
  border: 1px solid #aaa4aa;
  background: #fff;
  font-size: 8px;
}

.distribution-controls > div {
  display: flex;
}

.distribution-controls button {
  min-height: 31px;
  padding: 6px 9px;
  border: 1px solid #aaa4aa;
  background: #fff;
  font-size: 8px;
  font-weight: 800;
}

.distribution-controls button + button {
  border-left: 0;
}

.distribution-controls button.active {
  border-color: var(--teal-dark);
  background: var(--teal-dark);
  color: #fff;
}

.distribution-svg-wrap {
  overflow-x: auto;
  padding: 12px 14px 0;
}

.distribution-svg {
  display: block;
  width: 100%;
  min-width: 700px;
  height: auto;
  border: 1px solid #e0dcd8;
  background: #fff;
}

.distribution-svg text {
  fill: #625e63;
  font: 8px Arial, sans-serif;
}

.distribution-svg .distribution-axis-title {
  font-size: 8px;
  font-weight: 800;
}

.distribution-svg .distribution-method-label {
  fill: #8f272e;
  font-size: 7px;
}

.distribution-summary {
  padding: 12px 14px 14px;
}

.distribution-summary h5 {
  margin: 0 0 8px;
  color: var(--ink-soft);
  font-size: 8px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.distribution-summary > div {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.distribution-summary span {
  min-width: 0;
  padding: 8px 9px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.distribution-summary strong,
.distribution-summary small {
  display: block;
}

.distribution-summary strong {
  font-size: 8px;
}

.distribution-summary small {
  margin-top: 4px;
  color: var(--ink-soft);
  font-size: 7px;
  line-height: 1.35;
}

.comparison-statistics > header > span,
.pairwise-comparison > header > span,
.sample-audit > header > span {
  flex: 0 0 auto;
  padding: 5px 8px;
  border: 1px solid #b9cfc5;
  background: #edf6f1;
  color: var(--teal-dark);
  font-size: 8px;
  font-weight: 800;
}

.comparison-statistics .comparison-table-wrap {
  padding-bottom: 0;
}

.pairwise-controls {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 13px 16px 0;
}

.pairwise-controls > span {
  padding-bottom: 8px;
  color: var(--coral);
  font-size: 9px;
  font-weight: 900;
}

.pairwise-controls label,
.pairwise-controls label span {
  display: block;
}

.pairwise-controls label span {
  margin-bottom: 4px;
  color: var(--ink-soft);
  font-size: 7px;
  font-weight: 800;
}

.pairwise-controls select {
  min-width: 150px;
  height: 32px;
  border: 1px solid #aaa4aa;
  background: #fff;
  font-size: 8px;
}

.pairwise-table {
  width: 100%;
  min-width: 960px;
  border-collapse: collapse;
  font-size: 8px;
}

.pairwise-table th,
.pairwise-table td {
  padding: 9px 10px;
  border: 1px solid var(--line);
  text-align: left;
  vertical-align: middle;
}

.pairwise-table thead th {
  background: #f2f0ed;
  color: var(--ink-soft);
  font-weight: 800;
}

.pairwise-table tbody th {
  min-width: 130px;
  background: #fff;
}

.pairwise-table tbody th strong,
.pairwise-table tbody th code,
.pairwise-table td strong,
.pairwise-table td small {
  display: block;
}

.pairwise-table tbody th code,
.pairwise-table td small {
  margin-top: 3px;
  color: var(--ink-soft);
  font-size: 7px;
}

.statistics-caution {
  margin: 14px 18px 16px !important;
  padding: 10px 12px;
  border-left: 3px solid var(--amber);
  background: #fbf0d6;
  color: #6c5122;
  font-size: 8px;
  line-height: 1.5;
}

.replicate-check {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 14px 18px 0;
  padding: 11px 12px;
  border-left: 3px solid var(--amber);
  background: #fbf0d6;
}

.replicate-check.ready {
  border-left-color: var(--teal-dark);
  background: #edf6f1;
}

.replicate-check > div:first-child {
  max-width: 670px;
}

.replicate-check > div:first-child > strong {
  color: #5b451f;
  font-size: 8px;
}

.replicate-check p {
  margin-top: 4px;
  color: #6c5122;
  font-size: 8px;
  line-height: 1.45;
}

.replicate-check > div:last-child {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
}

.replicate-check > div:last-child span {
  min-width: 82px;
  padding: 6px 8px;
  border: 1px solid rgba(108, 81, 34, 0.24);
  background: rgba(255, 255, 255, 0.55);
}

.replicate-check > div:last-child strong,
.replicate-check > div:last-child small {
  display: block;
}

.replicate-check > div:last-child strong {
  font-size: 8px;
}

.replicate-check > div:last-child small {
  margin-top: 2px;
  color: var(--ink-soft);
  font-size: 7px;
}

.sample-audit-table {
  width: 100%;
  min-width: 850px;
  border-collapse: collapse;
  font-size: 8px;
}

.sample-audit-table th,
.sample-audit-table td {
  padding: 9px 10px;
  border: 1px solid var(--line);
  text-align: left;
  vertical-align: middle;
}

.sample-audit-table thead th {
  background: #f2f0ed;
  color: var(--ink-soft);
  font-weight: 800;
}

.sample-audit-table thead th strong,
.sample-audit-table thead th code,
.sample-audit-table thead th small,
.sample-audit-table tbody td strong,
.sample-audit-table tbody td small {
  display: block;
}

.sample-audit-table thead th code {
  margin-top: 2px;
  color: var(--ink);
  font-size: 7px;
}

.sample-audit-table thead th small {
  max-width: 145px;
  margin-top: 4px;
  font-size: 6.5px;
  line-height: 1.35;
}

.sample-audit-table tbody th {
  min-width: 92px;
  background: #fff;
}

.sample-audit-table tbody td strong {
  color: var(--teal-dark);
}

.sample-audit-table tbody td small {
  margin-top: 3px;
  color: var(--ink-soft);
  font-size: 7px;
}

.sample-composition-bar {
  display: flex;
  width: 190px;
  height: 9px;
  overflow: hidden;
  border-radius: 99px;
  background: #e6e1dd;
}

.sample-composition-bar span {
  min-width: 2px;
  height: 100%;
}

.sample-composition-labels {
  max-width: 230px;
  line-height: 1.35;
}

.sample-audit footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 13px 16px 15px;
}

.sample-audit footer p {
  max-width: 690px;
  color: var(--ink-soft);
  font-size: 8px;
  line-height: 1.5;
}

.sample-audit footer button {
  flex: 0 0 auto;
  min-height: 33px;
  padding: 7px 10px;
  border: 1px solid var(--teal-dark);
  background: #fff;
  color: var(--teal-dark);
  font-size: 8px;
  font-weight: 800;
}

.analysis-export {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin: 0 18px 18px;
  padding: 14px 16px;
  border: 1px solid #b9cfc5;
  background: #edf6f1;
}

.analysis-export p {
  max-width: 650px;
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 8px;
  line-height: 1.45;
}

.analysis-export > div:last-child {
  display: flex;
  flex: 0 0 auto;
  gap: 7px;
}

.analysis-export button {
  min-height: 33px;
  padding: 7px 10px;
  border: 1px solid var(--teal-dark);
  background: var(--teal-dark);
  color: #fff;
  font-size: 8px;
  font-weight: 800;
}

.analysis-export button + button {
  border-color: #8d4b42;
  background: #fff;
  color: #8d2c31;
}

.analysis-export button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.gene-record-panel {
  margin: -4px -4px 22px;
  padding: 16px;
  border: 1px solid #bcb7bd;
  background: #fff;
}

.gene-record-label {
  margin: 0 0 5px;
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.gene-record-panel h2 {
  margin: 0;
  font: 700 22px/1.1 Georgia, serif;
  overflow-wrap: anywhere;
}

.gene-record-panel > code {
  display: block;
  margin-top: 4px;
  color: var(--ink-soft);
  font-size: 9px;
}

.gene-product {
  margin: 12px 0 0;
  font: italic 11px/1.45 Georgia, serif;
}

.gene-location {
  margin: 5px 0 0;
  color: var(--ink-soft);
  font-size: 8px;
}

.gene-version-map {
  margin-top: 15px;
  padding-top: 13px;
  border-top: 1px solid var(--line);
}

.gene-version-map h3 {
  margin: 0 0 8px;
  font-size: 9px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.gene-version-map > div {
  display: grid;
  gap: 1px;
  padding: 7px 0;
  border-top: 1px dotted var(--line);
}

.gene-version-map span {
  color: var(--ink-soft);
  font-size: 8px;
}

.gene-version-map strong {
  font-size: 9px;
}

.gene-detail-status {
  margin: 12px 0 0;
  padding: 8px;
  background: #f3f0f3;
  color: var(--ink-soft);
  font-size: 8px;
}

.gene-detail-status.warning {
  border-left: 3px solid var(--amber);
  background: #fff8e8;
  color: #6c5627;
}

.gene-record-panel details {
  border-top: 1px solid var(--line);
}

.gene-record-panel summary {
  padding: 10px 0;
  cursor: pointer;
  font-size: 9px;
  font-weight: 800;
}

.gene-record-panel summary small {
  color: var(--ink-soft);
  font-size: 8px;
  font-weight: 400;
}

.gene-record-panel ul {
  display: grid;
  gap: 7px;
  margin: 0 0 12px;
  padding: 0;
  list-style: none;
}

.gene-record-panel li {
  display: grid;
  gap: 1px;
  padding-left: 8px;
  border-left: 2px solid #ddd7dc;
  font-size: 8px;
}

.gene-record-panel li a {
  width: fit-content;
  color: var(--coral);
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.gene-record-panel li strong {
  font-size: 8px;
  overflow-wrap: anywhere;
}

.gene-record-panel li span {
  color: var(--ink-soft);
}

.gene-record-link {
  display: block;
  margin-top: 13px;
  padding: 9px 10px;
  border: 1px solid var(--ink);
  background: var(--ink);
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  text-align: center;
}

.atlas-filters {
  max-height: 980px;
  overflow-y: auto;
  padding: 20px;
  background: #f5f3f5;
  transition: padding 180ms ease;
}

.atlas-filter-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 15px;
}

.atlas-filter-heading h2 {
  margin: 0;
  font-size: 20px;
}

.filter-collapse-toggle {
  display: inline-flex;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 6px 8px;
  border: 1px solid var(--ink);
  background: #fff;
  color: var(--ink);
  cursor: pointer;
  font-size: 10px;
  font-weight: 800;
  line-height: 1.2;
}

.filter-collapse-toggle > span:first-child {
  font-size: 14px;
  line-height: 1;
}

.atlas-filters.is-collapsed {
  overflow: hidden;
  padding: 16px 8px;
}

.atlas-filters.is-collapsed .atlas-filter-heading {
  flex-direction: column;
  margin-bottom: 0;
  text-align: center;
}

.atlas-filters.is-collapsed .filter-collapse-toggle > span:last-child {
  display: none;
}

.atlas-filter-content[hidden] {
  display: none;
}

.filter-technology {
  padding: 12px;
  border: 1px solid var(--line);
  background: #fff;
}

.filter-technology span,
.filter-technology strong {
  display: block;
}

.filter-technology span {
  color: var(--ink-soft);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.filter-technology strong {
  margin-top: 5px;
  font-size: 12px;
  line-height: 1.4;
}

.atlas-filters fieldset {
  margin: 15px 0 0;
  padding: 12px;
  border: 1px solid var(--line);
  background: #fff;
}

.atlas-filters legend {
  padding: 0 5px;
  font-size: 12px;
  font-weight: 800;
}

.filter-shortcuts {
  display: flex;
  gap: 7px;
  margin-bottom: 9px;
}

.filter-shortcuts button {
  padding: 0;
  border: 0;
  border-bottom: 1px solid;
  background: transparent;
  color: var(--coral);
  cursor: pointer;
  font-size: 10px;
}

.atlas-filters fieldset label {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: 6px 0;
  color: var(--ink-soft);
  font-size: 11px;
  line-height: 1.45;
}

.atlas-filters input {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  accent-color: var(--coral);
}

.atlas-filter-content > p {
  margin-top: 18px;
  color: var(--ink-soft);
  font-size: 10.5px;
  line-height: 1.5;
}

.atlas-loading {
  display: grid;
  min-height: 420px;
  color: var(--ink-soft);
  place-items: center;
}

.atlas-loading.error {
  color: var(--coral);
}

.atlas-record {
  padding: 38px;
}

.record-title h2 {
  margin: 16px 0 4px;
  font: 400 36px/1.15 Georgia, serif;
}

.record-title p {
  margin: 0;
  color: var(--ink-soft);
}

.record-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 35px 0 0;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.record-grid > div {
  min-height: 110px;
  padding: 18px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.record-grid dt {
  color: var(--ink-soft);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.record-grid dd {
  margin: 17px 0 0;
  font: 400 17px/1.25 Georgia, serif;
}

.record-explanation {
  max-width: 900px;
  margin-top: 30px;
  color: var(--ink-soft);
  font-size: 12px;
}

.data-access-audit {
  margin-top: 30px;
  padding: 22px;
  border: 1px solid var(--line);
  background: #f7f5f2;
}

.data-access-audit > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.data-access-audit h3 {
  margin: 4px 0 0;
  font: 700 22px/1.2 Georgia, serif;
}

.data-access-audit > header > span {
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
}

.data-access-audit > p {
  max-width: 850px;
  color: var(--ink-soft);
  font-size: 11px;
}

.data-access-audit dl {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 18px 0 0;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.data-access-audit dl > div {
  min-width: 0;
  padding: 14px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.data-access-audit dt {
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.data-access-audit dd {
  margin: 8px 0 0;
  font-size: 10px;
  line-height: 1.5;
}

.data-access-audit .audit-warning {
  background: #fff4df;
}

.audit-links {
  display: flex;
  flex-wrap: wrap;
  gap: 9px 18px;
  margin-top: 16px;
}

.audit-links a {
  border-bottom: 1px solid;
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
}

.record-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 20px;
  margin-top: 25px;
}

.record-links a {
  border-bottom: 1px solid;
  color: var(--teal-dark);
  font-size: 11px;
  font-weight: 800;
}

.record-links small {
  color: var(--ink-soft);
  font-size: 9px;
}

.checksum-details {
  margin-top: 25px;
  padding: 15px;
  border: 1px solid var(--line);
  font-size: 10px;
}

.checksum-details summary {
  cursor: pointer;
  font-weight: 800;
}

.checksum-details code {
  display: block;
  overflow-x: auto;
  margin-top: 8px;
  color: var(--ink-soft);
  white-space: nowrap;
}

.embedded-host-panel {
  display: grid;
  grid-template-columns: minmax(0, 1.25fr) minmax(280px, 0.75fr);
  gap: 55px;
  padding: 50px;
}

.embedded-host-panel h2 {
  margin: 0;
  font: 400 42px/1.1 Georgia, serif;
}

.embedded-host-panel p {
  max-width: 720px;
  color: var(--ink-soft);
}

.embedded-host-panel .boundary-note {
  margin-top: 24px;
  padding: 15px;
  border-left: 3px solid var(--coral);
  background: var(--plum-light);
}

.host-source-summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.host-source-summary > div,
.host-source-summary > a {
  min-height: 100px;
  padding: 16px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.host-source-summary strong,
.host-source-summary span {
  display: block;
}

.host-source-summary strong {
  font: 400 31px/1 Georgia, serif;
}

.host-source-summary span {
  margin-top: 8px;
  color: var(--ink-soft);
  font-size: 9px;
}

.host-source-summary a {
  display: grid;
  align-items: center;
  color: var(--teal-dark);
  font-size: 10px;
  font-weight: 800;
}

.policy-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
  background: var(--line);
}

.policy-grid article {
  min-height: 260px;
  padding: 32px;
  background: #fff;
}

.policy-grid h2 {
  font: 400 25px/1.2 Georgia, serif;
}

.policy-grid p {
  color: var(--ink-soft);
  font-size: 13px;
}

.cookie-notice {
  position: fixed;
  z-index: 100;
  right: 20px;
  bottom: 20px;
  left: 20px;
  display: flex;
  max-width: 840px;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  margin: auto;
  padding: 18px 20px;
  border: 1px solid #171719;
  background: #fff;
  box-shadow: 0 14px 45px rgba(20, 18, 20, 0.2);
}

.cookie-notice strong {
  font-size: 13px;
}

.cookie-notice p {
  margin: 4px 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.cookie-notice a {
  border-bottom: 1px solid;
  font-size: 9px;
}

.cookie-notice > div:last-child {
  display: flex;
  flex: 0 0 auto;
  gap: 7px;
}

.cookie-notice button {
  padding: 8px 11px;
  border: 1px solid var(--ink);
  background: #fff;
  cursor: pointer;
  font-size: 9px;
  font-weight: 800;
}

.cookie-notice .cookie-primary {
  background: var(--ink);
  color: #fff;
}

.site-footer {
  background: #211f22;
}

@media (max-width: 1120px) {
  .header-inner {
    grid-template-columns: 1fr auto;
  }

  .coverage-explorer {
    grid-template-columns: 280px minmax(0, 1fr);
  }

  .atlas-workspace {
    grid-template-columns: minmax(0, 1fr) 230px;
  }

  .plot-controls {
    grid-template-columns: 1fr 1fr;
  }

  .gene-search-panel {
    grid-template-columns: 1fr;
  }

  .paper-marker-grid,
  .data-access-audit dl {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .point-slider {
    grid-column: 1 / -1;
  }

  .selected-cell-detail-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .selected-cell-detail-grid > :nth-child(2n) {
    border-right: 0;
  }

  .selected-cell-detail-grid > :nth-child(-n + 2) {
    border-bottom: 1px solid var(--line);
  }
}

@media (max-width: 820px) {
  .header-inner,
  .home-intro,
  .home-explorer.section,
  .section,
  .page-hero {
    width: min(100% - 32px, 1200px);
  }

  .brand-mark {
    width: 52px;
    height: 52px;
  }

  .brand-mark::before,
  .brand-mark::after {
    width: 38px;
    height: 14px;
  }

  .brand-mark i:nth-child(1) {
    top: 9px;
    left: 24px;
  }

  .brand-mark i:nth-child(2) {
    top: 22px;
    left: 10px;
  }

  .brand-mark i:nth-child(3) {
    top: 24px;
    right: 9px;
  }

  .brand-mark i:nth-child(4) {
    bottom: 8px;
    left: 20px;
  }

  .brand-mark i:nth-child(5) {
    right: 17px;
    bottom: 12px;
  }

  .brand strong {
    font-size: 26px;
  }

  .coverage-explorer {
    grid-template-columns: 1fr;
  }

  .coverage-species {
    padding-right: 0;
  }

  .coverage-map {
    min-height: 620px;
  }

  .live-atlas-grid,
  .atlas-workspace,
  .embedded-host-panel,
  .policy-grid {
    grid-template-columns: 1fr;
  }

  .atlas-workspace.filters-collapsed {
    grid-template-columns: 1fr;
  }

  .live-atlas-grid .gap-summary {
    grid-column: auto;
  }

  .plot-column {
    border-right: 0;
  }

  .atlas-filters {
    max-height: none;
    border-top: 1px solid var(--line);
  }

  .atlas-filters.is-collapsed {
    padding: 12px 16px;
  }

  .atlas-filters.is-collapsed .atlas-filter-heading {
    flex-direction: row;
    text-align: left;
  }

  .atlas-filters.is-collapsed .filter-collapse-toggle > span:last-child {
    display: inline;
  }

  .record-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .atlas-view-header,
  .plot-foot {
    align-items: flex-start;
    flex-direction: column;
  }

  .download-actions {
    justify-content: flex-start;
  }

  .selected-cell-detail > header,
  .selected-set-detail > header {
    flex-direction: column;
  }

  .selected-cell-detail-grid,
  .selected-set-grid {
    grid-template-columns: 1fr;
  }

  .selected-cell-detail-grid > section,
  .selected-cell-detail-grid > aside {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .selected-cell-detail-grid > :last-child {
    border-bottom: 0;
  }

  .gene-search-panel {
    padding: 16px 18px;
  }

  .expression-stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .plot-hover-readout,
  .plot-hover-readout.gene-hover-readout {
    grid-template-columns: 1fr;
  }

  .hover-readout-id {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .gene-comparison-panel > header,
  .cell-type-comparison > div:first-child,
  .distribution-explorer > header,
  .comparison-statistics > header,
  .pairwise-comparison > header,
  .sample-audit > header,
  .sample-audit footer,
  .replicate-check,
  .analysis-export {
    align-items: flex-start;
    flex-direction: column;
  }

  .comparison-actions {
    justify-content: flex-start;
  }

  .distribution-controls {
    width: 100%;
    flex-wrap: wrap;
  }

  .pairwise-controls {
    align-items: stretch;
    flex-direction: column;
  }

  .pairwise-controls > span {
    padding: 0;
  }

  .pairwise-controls select {
    width: 100%;
  }

  .analysis-export > div:last-child {
    width: 100%;
    flex-wrap: wrap;
  }

  .replicate-check > div:last-child {
    flex-wrap: wrap;
  }

  .sample-audit footer button {
    width: 100%;
  }
}

@media (max-width: 540px) {
  .header-inner {
    min-height: 74px;
  }

  .brand-mark {
    display: none;
  }

  .brand strong {
    font-size: 21px;
  }

  .home-intro {
    padding-top: 42px;
  }

  .home-intro h1,
  .page-hero h1 {
    font-size: 36px;
  }

  .coverage-map {
    padding: 28px 18px;
  }

  .coverage-map-heading {
    display: block;
  }

  .coverage-map-heading > div:last-child {
    margin-top: 18px;
    text-align: left;
  }

  .stage-orbit {
    grid-template-columns: repeat(2, 1fr);
    gap: 35px 16px;
  }

  .orbit-line {
    display: none;
  }

  .coverage-map footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .atlas-species-tabs {
    grid-template-columns: 1fr;
  }

  .atlas-species-tabs button {
    border-right: 0;
  }

  .atlas-section-tabs {
    overflow-x: auto;
  }

  .atlas-view-header {
    padding: 16px;
  }

  .view-switch {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .view-switch small {
    width: 100%;
    max-width: none;
    margin: 5px 0 0;
  }

  .atlas-dataset-line {
    text-align: left;
  }

  .plot-column {
    padding: 8px;
  }

  .plot-controls {
    grid-template-columns: 1fr;
  }

  .point-slider {
    grid-column: auto;
  }

  .gene-search-panel {
    padding: 14px 8px;
  }

  .paper-marker-panel > header,
  .data-access-audit > header {
    align-items: flex-start;
    flex-direction: column;
  }

  .paper-marker-grid,
  .data-access-audit dl {
    grid-template-columns: 1fr;
  }

  .marker-gene-buttons button {
    flex-basis: calc(50% - 4px);
  }

  .plot-controls label,
  .control-group {
    align-items: flex-start;
    flex-direction: column;
  }

  .control-group {
    flex-direction: row;
  }

  .expression-legend {
    grid-template-columns: auto minmax(80px, 1fr) auto;
  }

  .expression-legend span:last-child {
    grid-column: 1 / -1;
  }

  .expression-distribution-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .expression-distribution-heading span {
    text-align: left;
  }

  .plot-toolbar button {
    white-space: nowrap;
  }

  .record-grid {
    grid-template-columns: 1fr;
  }

  .atlas-record,
  .embedded-host-panel {
    padding: 26px 18px;
  }

  .cookie-notice {
    align-items: stretch;
    flex-direction: column;
    gap: 12px;
  }
}

/* E-MTAB-14406 sample and sequencing-run provenance */

.run-page-hero {
  position: relative;
}

.run-page-hero::after {
  position: absolute;
  right: 0;
  bottom: 0;
  width: min(36vw, 460px);
  height: 8px;
  background:
    linear-gradient(
      90deg,
      var(--teal) 0 24%,
      var(--amber) 24% 48%,
      var(--coral) 48% 72%,
      var(--ink) 72% 100%
    );
  content: "";
}

.run-hero-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 26px;
  margin-top: 30px;
}

.run-hero-links a {
  border-bottom: 1px solid var(--ink-soft);
  color: var(--ink-soft);
  font-size: 12px;
  font-weight: 700;
}

.run-browser-section {
  padding-top: 52px;
}

.run-browser {
  display: grid;
  gap: 24px;
}

.run-source-banner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 30px;
  padding: 26px 28px;
  border: 1px solid rgba(11, 117, 108, 0.28);
  background: var(--mint);
}

.run-source-banner span {
  display: block;
  margin-bottom: 7px;
  color: var(--teal-dark);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.run-source-banner code {
  display: block;
  overflow-wrap: anywhere;
  font-size: 11px;
}

.run-source-banner p {
  max-width: 850px;
  margin: 12px 0 0;
  color: var(--ink-soft);
  font-size: 12px;
}

.run-source-actions {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  flex-direction: column;
}

.run-source-actions a {
  border-bottom: 1px solid var(--teal-dark);
  color: var(--teal-dark);
  font-size: 11px;
  font-weight: 800;
}

.run-library-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  border: 1px solid var(--line);
  background: var(--white);
}

.run-library-strip > div {
  min-width: 0;
  padding: 18px;
  border-right: 1px solid var(--line);
}

.run-library-strip > div:last-child {
  border-right: 0;
}

.run-library-strip span,
.run-library-strip strong {
  display: block;
}

.run-library-strip span {
  margin-bottom: 5px;
  color: var(--ink-soft);
  font-size: 9px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.run-library-strip strong {
  font: 400 16px/1.2 var(--serif);
}

.run-controls {
  display: grid;
  grid-template-columns: minmax(300px, 1fr) auto;
  gap: 16px;
}

.run-search {
  display: flex;
  min-height: 54px;
  align-items: center;
  gap: 12px;
  padding: 0 18px;
  border: 1px solid var(--line);
  background: var(--white);
}

.run-search input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--ink);
}

.run-scope {
  display: flex;
  padding: 4px;
  border: 1px solid var(--line);
  background: var(--white);
}

.run-scope button,
.run-results-heading button {
  padding: 9px 13px;
  border: 0;
  background: transparent;
  color: var(--ink-soft);
  cursor: pointer;
  font-size: 11px;
}

.run-scope button.active {
  background: var(--ink);
  color: var(--white);
}

.run-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 1px solid var(--line);
  background: var(--ink);
  color: var(--white);
}

.run-stats > div {
  display: flex;
  min-height: 86px;
  align-items: baseline;
  gap: 9px;
  padding: 20px 24px;
  border-right: 1px solid rgba(255, 255, 255, 0.18);
}

.run-stats > div:last-child {
  border-right: 0;
}

.run-stats strong {
  color: var(--amber);
  font: 400 34px/1 var(--serif);
}

.run-stats span {
  font-size: 10px;
  letter-spacing: 0.04em;
}

.sample-selector {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.sample-selector button {
  display: grid;
  min-height: 76px;
  grid-template-columns: 34px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1px solid var(--line);
  background: rgba(255, 254, 249, 0.65);
  color: var(--ink);
  cursor: pointer;
  text-align: left;
}

.sample-selector button > span {
  display: grid;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--mint);
  color: var(--teal-dark);
  font: italic 12px/1 var(--serif);
  place-items: center;
}

.sample-selector button strong {
  font-size: 11px;
  line-height: 1.35;
}

.sample-selector button small {
  color: var(--ink-soft);
  font-size: 9px;
  white-space: nowrap;
}

.sample-selector button.active {
  border-color: var(--teal);
  background: var(--white);
  box-shadow: inset 0 -3px 0 var(--teal);
}

.sample-selector button.active > span {
  background: var(--teal);
  color: var(--white);
}

.run-results {
  margin-top: 8px;
}

.run-results-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  color: var(--ink-soft);
  font-size: 11px;
}

.run-results-heading strong {
  color: var(--ink);
  font: 400 24px/1 var(--serif);
}

.run-results-heading button {
  border-bottom: 1px solid var(--ink-soft);
  padding: 4px 0;
}

.run-record-list {
  display: grid;
  gap: 12px;
}

.run-record {
  border: 1px solid var(--line);
  background: var(--white);
}

.run-record > header {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) auto;
  align-items: center;
  gap: 18px;
  padding: 22px 24px;
  border-bottom: 1px solid var(--line);
}

.run-number {
  display: grid;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--ink);
  color: var(--white);
  font: italic 14px/1 var(--serif);
  place-items: center;
}

.run-record > header span {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.run-record > header h2 {
  margin: 3px 0 0;
  font: 400 25px/1.1 var(--serif);
}

.run-record > header p {
  margin: 5px 0 0;
  color: var(--ink-soft);
  font-family: monospace;
  font-size: 10px;
  overflow-wrap: anywhere;
}

.run-record > header > a {
  padding: 9px 12px;
  border: 1px solid var(--teal);
  color: var(--teal-dark);
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.run-record-meta {
  display: grid;
  grid-template-columns: 1fr 1.6fr 0.8fr;
}

.run-record-meta > div {
  min-width: 0;
  padding: 18px 24px;
  border-right: 1px solid var(--line);
}

.run-record-meta > div:last-child {
  border-right: 0;
}

.run-record-meta span,
.run-record-meta strong,
.run-record-meta p {
  display: block;
}

.run-record-meta span {
  margin-bottom: 6px;
  color: var(--ink-soft);
  font-size: 9px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.run-record-meta strong {
  font-size: 11px;
  line-height: 1.4;
}

.run-record-meta p {
  margin: 7px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
  line-height: 1.4;
}

.run-record-meta p a {
  margin-right: 11px;
  border-bottom: 1px solid var(--line);
}

.fastq-files {
  border-top: 1px solid var(--line);
}

.fastq-files summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  color: var(--teal-dark);
  cursor: pointer;
  font-size: 10px;
  font-weight: 800;
  list-style: none;
}

.fastq-files summary::-webkit-details-marker {
  display: none;
}

.fastq-files summary::before {
  margin-right: 8px;
  content: "+";
}

.fastq-files[open] summary::before {
  content: "−";
}

.fastq-files summary span {
  margin-right: auto;
}

.fastq-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 13px 24px;
  border-top: 1px solid var(--line);
  background: rgba(223, 238, 231, 0.42);
}

.fastq-legend span {
  padding: 4px 7px;
  border: 1px solid rgba(11, 117, 108, 0.22);
  color: var(--ink-soft);
  font-size: 8px;
}

.fastq-file-list {
  border-top: 1px solid var(--line);
}

.fastq-file-list a {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr) 20px;
  align-items: center;
  gap: 16px;
  padding: 11px 24px;
  border-bottom: 1px solid var(--line);
}

.fastq-file-list a:last-child {
  border-bottom: 0;
}

.fastq-file-list a:hover {
  background: rgba(223, 238, 231, 0.32);
}

.fastq-file-list a > span {
  display: grid;
}

.fastq-file-list strong {
  font-size: 10px;
}

.fastq-file-list small {
  color: var(--ink-soft);
  font-size: 8px;
}

.fastq-file-list code {
  min-width: 0;
  color: var(--ink-soft);
  font-size: 9px;
  overflow-wrap: anywhere;
}

.fastq-file-list b {
  color: var(--teal);
  font-size: 13px;
}

.run-empty {
  padding: 70px 24px;
  border: 1px solid var(--line);
  background: var(--white);
  color: var(--ink-soft);
  text-align: center;
}

@media (max-width: 980px) {
  .run-library-strip {
    grid-template-columns: repeat(3, 1fr);
  }

  .run-library-strip > div:nth-child(3) {
    border-right: 0;
  }

  .run-library-strip > div:nth-child(-n + 3) {
    border-bottom: 1px solid var(--line);
  }

  .run-controls {
    grid-template-columns: 1fr;
  }

  .run-scope {
    width: fit-content;
  }

  .sample-selector {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .run-record-meta {
    grid-template-columns: 1fr 1fr;
  }

  .run-record-meta > div:nth-child(2) {
    border-right: 0;
  }

  .run-record-meta > div:last-child {
    grid-column: 1 / -1;
    border-top: 1px solid var(--line);
  }
}

@media (max-width: 680px) {
  .run-source-banner {
    grid-template-columns: 1fr;
  }

  .run-source-actions {
    align-items: flex-start;
  }

  .run-library-strip,
  .run-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .run-library-strip > div,
  .run-library-strip > div:nth-child(3) {
    border-right: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
  }

  .run-library-strip > div:nth-child(2n),
  .run-stats > div:nth-child(2n) {
    border-right: 0;
  }

  .run-library-strip > div:nth-last-child(-n + 2) {
    border-bottom: 0;
  }

  .run-stats > div:nth-child(-n + 2) {
    border-bottom: 1px solid rgba(255, 255, 255, 0.18);
  }

  .run-scope {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }

  .sample-selector {
    grid-template-columns: 1fr;
  }

  .run-record > header {
    grid-template-columns: 44px minmax(0, 1fr);
    padding: 18px;
  }

  .run-record > header > a {
    grid-column: 1 / -1;
    text-align: center;
  }

  .run-record-meta {
    grid-template-columns: 1fr;
  }

  .run-record-meta > div,
  .run-record-meta > div:nth-child(2) {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .run-record-meta > div:last-child {
    grid-column: auto;
    border-top: 0;
    border-bottom: 0;
  }

  .fastq-file-list a {
    grid-template-columns: 90px minmax(0, 1fr) 12px;
    gap: 8px;
    padding: 11px 14px;
  }
}

/* PRJNA1200704 provenance and reproducibility audit */

.inchausti-page-hero {
  position: relative;
}

.inchausti-page-hero::after {
  position: absolute;
  right: 0;
  bottom: 0;
  width: min(42vw, 560px);
  height: 8px;
  background:
    linear-gradient(
      90deg,
      var(--coral) 0 33%,
      var(--amber) 33% 66%,
      var(--teal) 66% 100%
    );
  content: "";
}

.inchausti-browser-section {
  padding-top: 52px;
}

.inchausti-browser {
  display: grid;
  gap: 20px;
}

.inchausti-source-note {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 24px;
  padding: 22px 26px;
  border: 1px solid rgba(217, 107, 77, 0.34);
  background: rgba(233, 188, 101, 0.18);
}

.inchausti-source-note span {
  display: block;
  margin-bottom: 6px;
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.inchausti-source-note p {
  max-width: 900px;
  margin: 0;
  color: var(--ink-soft);
  font-size: 12px;
}

.inchausti-source-note a {
  padding: 10px 13px;
  border: 1px solid var(--coral);
  color: var(--coral);
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.inchausti-tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border: 1px solid var(--line);
  background: var(--white);
}

.inchausti-tabs button {
  min-height: 54px;
  border: 0;
  border-right: 1px solid var(--line);
  background: transparent;
  color: var(--ink-soft);
  cursor: pointer;
  font-size: 11px;
  font-weight: 800;
}

.inchausti-tabs button:last-child {
  border-right: 0;
}

.inchausti-tabs button.active {
  background: var(--ink);
  color: var(--white);
  box-shadow: inset 0 -4px 0 var(--amber);
}

.inchausti-provenance,
.inchausti-method {
  display: grid;
  gap: 20px;
}

.provenance-flow {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid var(--line);
  background: var(--white);
}

.provenance-flow > div {
  position: relative;
  min-width: 0;
  min-height: 104px;
  padding: 20px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.provenance-flow > div:nth-child(4n) {
  border-right: 0;
}

.provenance-flow > div:nth-last-child(-n + 4) {
  border-bottom: 0;
}

.provenance-flow > div::after {
  position: absolute;
  z-index: 1;
  top: 48%;
  right: -7px;
  width: 13px;
  height: 13px;
  border-top: 1px solid var(--line);
  border-right: 1px solid var(--line);
  background: var(--white);
  content: "";
  transform: rotate(45deg);
}

.provenance-flow > div:nth-child(4n)::after,
.provenance-flow > div:last-child::after {
  display: none;
}

.provenance-flow span,
.provenance-flow strong,
.provenance-flow small {
  display: block;
}

.provenance-flow span {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.provenance-flow strong {
  margin-top: 8px;
  font: 400 20px/1.15 var(--serif);
  overflow-wrap: anywhere;
}

.provenance-flow small {
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 9px;
}

.inchausti-record-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.inchausti-record-card,
.paper-clusters,
.method-discrepancy,
.method-facts article,
.no-reconstruction {
  border: 1px solid var(--line);
  background: var(--white);
}

.inchausti-record-card > header,
.paper-clusters > header,
.method-discrepancy > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px;
  border-bottom: 1px solid var(--line);
}

.inchausti-record-card > header span,
.paper-clusters > header span,
.method-discrepancy > header span,
.method-facts article > span,
.no-reconstruction > span {
  display: block;
  margin-bottom: 4px;
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.inchausti-record-card > header h2,
.paper-clusters > header h2,
.method-discrepancy > header h2,
.no-reconstruction h2 {
  margin: 0;
  font: 400 24px/1.15 var(--serif);
}

.inchausti-record-card > header a {
  border-bottom: 1px solid var(--teal);
  color: var(--teal-dark);
  font-size: 10px;
  font-weight: 800;
  white-space: nowrap;
}

.inchausti-record-card dl {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0;
}

.inchausti-record-card dl > div {
  min-width: 0;
  padding: 14px 16px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.inchausti-record-card dl > div:nth-child(3n) {
  border-right: 0;
}

.inchausti-record-card dt {
  color: var(--ink-soft);
  font-size: 8px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.inchausti-record-card dd {
  margin: 5px 0 0;
  font-size: 10px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.record-source-boundary {
  margin: 0;
  padding: 14px 18px;
  border-top: 1px solid var(--line);
  background: var(--amber-pale);
  color: var(--ink-soft);
  font-size: 9px;
}

.inchausti-fastq-list {
  padding: 0 18px 18px;
}

.inchausti-fastq-list a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 6px;
  border-bottom: 1px solid var(--line);
}

.inchausti-fastq-list a:last-child {
  border-bottom: 0;
}

.inchausti-fastq-list strong,
.inchausti-fastq-list small {
  display: block;
}

.inchausti-fastq-list strong {
  font-family: monospace;
  font-size: 10px;
}

.inchausti-fastq-list small {
  margin-top: 3px;
  color: var(--ink-soft);
  font-size: 8px;
  overflow-wrap: anywhere;
}

.inchausti-fastq-list b {
  color: var(--teal);
  font-size: 9px;
  white-space: nowrap;
}

.processed-summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid var(--line);
}

.processed-summary > div {
  padding: 20px;
  border-right: 1px solid var(--line);
}

.processed-summary > div:last-child {
  border-right: 0;
}

.processed-summary strong,
.processed-summary span {
  display: block;
}

.processed-summary strong {
  color: var(--teal-dark);
  font: 400 24px/1 var(--serif);
}

.processed-summary span {
  margin-top: 6px;
  color: var(--ink-soft);
  font-size: 8px;
  text-transform: uppercase;
}

.matrix-summary {
  padding: 20px 24px 24px;
}

.matrix-summary h3 {
  margin: 0 0 14px;
  font: 400 17px/1.2 var(--serif);
}

.matrix-summary > div {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 3px 12px;
  padding: 11px 0;
  border-top: 1px solid var(--line);
}

.matrix-summary code {
  font-size: 9px;
  overflow-wrap: anywhere;
}

.matrix-summary > div > span {
  font-size: 10px;
  font-weight: 800;
}

.matrix-summary > div > small {
  grid-column: 1 / -1;
  color: var(--ink-soft);
  font-size: 8px;
}

.matrix-summary > p {
  margin: 14px 0 0;
  padding: 13px;
  background: var(--mint);
  color: var(--ink-soft);
  font-size: 10px;
}

.matrix-summary > p strong {
  color: var(--teal-dark);
  font: 400 18px/1 var(--serif);
}

.paper-clusters > header > small {
  color: var(--ink-soft);
  font-size: 9px;
  text-align: right;
}

.paper-clusters > div {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.paper-clusters article {
  min-width: 0;
  padding: 22px 24px;
  border-right: 1px solid var(--line);
}

.paper-clusters article:last-child {
  border-right: 0;
}

.paper-clusters article > span,
.paper-clusters article > strong,
.paper-clusters article > code {
  display: block;
}

.paper-clusters article > span {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
}

.paper-clusters article > strong {
  margin: 7px 0;
  font: 400 40px/1 var(--serif);
}

.paper-clusters article > p {
  min-height: 36px;
  margin: 0 0 10px;
  color: var(--ink-soft);
  font-size: 11px;
}

.paper-clusters article > code {
  color: var(--teal-dark);
  font-size: 9px;
  overflow-wrap: anywhere;
}

.paper-clusters > p {
  margin: 0;
  padding: 13px 24px;
  border-top: 1px solid var(--line);
  background: rgba(233, 188, 101, 0.18);
  color: var(--ink-soft);
  font-size: 10px;
}

.inchausti-file-tools {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) auto;
  gap: 14px;
}

.inchausti-file-tools > label {
  display: flex;
  min-height: 52px;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  border: 1px solid var(--line);
  background: var(--white);
}

.inchausti-file-tools input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
}

.inchausti-file-tools > div {
  display: flex;
  padding: 4px;
  border: 1px solid var(--line);
  background: var(--white);
}

.inchausti-file-tools button {
  padding: 8px 10px;
  border: 0;
  background: transparent;
  color: var(--ink-soft);
  cursor: pointer;
  font-size: 9px;
}

.inchausti-file-tools button.active {
  background: var(--ink);
  color: var(--white);
}

.inchausti-file-count {
  margin: 24px 0 10px;
  color: var(--ink-soft);
  font-size: 10px;
}

.inchausti-file-count strong {
  color: var(--ink);
  font: 400 24px/1 var(--serif);
}

.zenodo-file-list {
  border-top: 1px solid var(--line);
}

.zenodo-file-list article {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) 230px 82px;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid var(--line);
}

.zenodo-file-list article > span {
  display: grid;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--mint);
  color: var(--teal-dark);
  font: italic 11px/1 var(--serif);
  place-items: center;
}

.zenodo-file-list article > div {
  min-width: 0;
}

.zenodo-file-list article small,
.zenodo-file-list article code,
.zenodo-file-list article p,
.zenodo-file-list article strong {
  display: block;
}

.zenodo-file-list article small {
  color: var(--ink-soft);
  font-size: 8px;
  overflow-wrap: anywhere;
}

.zenodo-file-list article code {
  margin-top: 3px;
  font-size: 10px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.zenodo-file-list article p {
  margin: 3px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.zenodo-file-list article > div:nth-child(3) {
  text-align: right;
}

.zenodo-file-list article > div:nth-child(3) strong {
  font: 400 15px/1.2 var(--serif);
}

.zenodo-file-list article > a {
  padding: 8px 10px;
  border: 1px solid var(--teal);
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
  text-align: center;
}

.inchausti-no-files {
  padding: 70px 20px;
  color: var(--ink-soft);
  text-align: center;
}

.method-discrepancy {
  border-color: rgba(217, 107, 77, 0.42);
}

.method-discrepancy > header {
  background: rgba(217, 107, 77, 0.08);
}

.threshold-table {
  display: grid;
}

.threshold-table > div {
  display: grid;
  grid-template-columns: 1fr 1.3fr 1.3fr;
  border-bottom: 1px solid var(--line);
}

.threshold-table > div:last-child {
  border-bottom: 0;
}

.threshold-table > div > * {
  min-width: 0;
  padding: 13px 20px;
  border-right: 1px solid var(--line);
  font-size: 10px;
}

.threshold-table > div > *:last-child {
  border-right: 0;
}

.threshold-table > div:first-child {
  background: rgba(223, 238, 231, 0.35);
}

.threshold-table .different {
  background: rgba(217, 107, 77, 0.12);
  color: #a43d24;
  font-weight: 800;
}

.method-audit-conclusion {
  padding: 20px 24px;
  border-top: 1px solid rgba(217, 107, 77, 0.42);
  background: rgba(217, 107, 77, 0.08);
}

.method-audit-conclusion span {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.method-audit-conclusion p {
  max-width: 950px;
  margin: 6px 0 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.method-facts {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.method-facts article {
  padding: 22px 24px;
}

.method-facts h3 {
  margin: 5px 0 9px;
  font: 400 19px/1.2 var(--serif);
}

.method-facts p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.method-facts small {
  display: block;
  margin-top: 9px;
  color: var(--teal-dark);
  font-size: 9px;
}

.method-facts code {
  overflow-wrap: anywhere;
}

.method-facts a {
  display: inline-block;
  margin-top: 12px;
  border-bottom: 1px solid var(--teal);
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
}

.no-reconstruction {
  padding: 26px;
  border-color: rgba(11, 117, 108, 0.34);
  background: var(--mint);
}

.no-reconstruction p {
  max-width: 970px;
  margin: 10px 0 0;
  color: var(--ink-soft);
  font-size: 11px;
}

@media (max-width: 1040px) {
  .inchausti-record-grid {
    grid-template-columns: 1fr;
  }

  .inchausti-file-tools {
    grid-template-columns: 1fr;
  }

  .inchausti-file-tools > div {
    width: fit-content;
  }
}

@media (max-width: 760px) {
  .inchausti-source-note {
    grid-template-columns: 1fr;
  }

  .inchausti-source-note a {
    width: fit-content;
  }

  .provenance-flow {
    grid-template-columns: repeat(2, 1fr);
  }

  .provenance-flow > div,
  .provenance-flow > div:nth-child(4n) {
    border-right: 1px solid var(--line);
    border-bottom: 1px solid var(--line);
  }

  .provenance-flow > div:nth-child(2n) {
    border-right: 0;
  }

  .provenance-flow > div:nth-last-child(-n + 2) {
    border-bottom: 0;
  }

  .provenance-flow > div:nth-child(4n)::after {
    display: block;
  }

  .provenance-flow > div:nth-child(2n)::after {
    display: none;
  }

  .paper-clusters > div,
  .method-facts {
    grid-template-columns: 1fr;
  }

  .paper-clusters article {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .paper-clusters article:last-child {
    border-bottom: 0;
  }

  .zenodo-file-list article {
    grid-template-columns: 36px minmax(0, 1fr) 70px;
  }

  .zenodo-file-list article > div:nth-child(3) {
    text-align: right;
  }

  .zenodo-file-list article > a {
    grid-column: 2 / -1;
  }
}

@media (max-width: 560px) {
  .inchausti-tabs {
    grid-template-columns: 1fr;
  }

  .inchausti-tabs button {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .inchausti-tabs button:last-child {
    border-bottom: 0;
  }

  .inchausti-record-card > header,
  .paper-clusters > header,
  .method-discrepancy > header {
    align-items: flex-start;
    flex-direction: column;
  }

  .inchausti-record-card dl {
    grid-template-columns: repeat(2, 1fr);
  }

  .inchausti-record-card dl > div,
  .inchausti-record-card dl > div:nth-child(3n) {
    border-right: 1px solid var(--line);
  }

  .inchausti-record-card dl > div:nth-child(2n) {
    border-right: 0;
  }

  .processed-summary {
    grid-template-columns: 1fr;
  }

  .processed-summary > div {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .processed-summary > div:last-child {
    border-bottom: 0;
  }

  .inchausti-file-tools > div {
    width: 100%;
    align-items: stretch;
    flex-direction: column;
  }

  .zenodo-file-list article {
    grid-template-columns: 32px minmax(0, 1fr);
  }

  .zenodo-file-list article > div:nth-child(3),
  .zenodo-file-list article > a {
    grid-column: 2;
    text-align: left;
  }

  .threshold-table > div {
    grid-template-columns: 0.8fr 1fr 1fr;
  }

  .threshold-table > div > * {
    padding: 11px 8px;
    font-size: 8px;
    overflow-wrap: anywhere;
  }
}

/* Research data passports and public scientific standards */
.dataset-passport {
  margin-top: 18px;
  border: 1px solid var(--line);
  background: rgba(255, 254, 249, 0.64);
}

.dataset-passport summary {
  display: flex;
  min-height: 46px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 10px 14px;
  color: var(--teal-dark);
  cursor: pointer;
  font-size: 10px;
  font-weight: 800;
}

.dataset-passport summary small {
  color: var(--ink-soft);
  font-size: 8px;
  font-weight: 600;
}

.dataset-passport-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid var(--line);
}

.dataset-passport-grid > div {
  min-width: 0;
  padding: 14px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.dataset-passport-grid > div:nth-child(2n) {
  border-right: 0;
}

.dataset-passport-grid > div:nth-last-child(-n + 2) {
  border-bottom: 0;
}

.dataset-passport-grid span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.09em;
}

.dataset-passport-grid p {
  margin: 7px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.dataset-passport-grid a {
  border-bottom: 1px solid currentColor;
  color: var(--teal-dark);
}

.dataset-links a {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
}

.standards-section {
  padding-top: 58px;
  padding-bottom: 110px;
}

.standards-release-strip,
.fair-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.standards-release-strip article,
.fair-grid article {
  min-height: 190px;
  padding: 27px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.standards-release-strip span,
.fair-grid span,
.standards-policy-grid > article > span,
.governance-standard-list > article > span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.standards-release-strip strong {
  display: block;
  margin-top: 36px;
  overflow-wrap: anywhere;
  font: 400 29px/1.08 var(--serif);
}

.standards-release-strip p,
.fair-grid p,
.standards-policy-grid p,
.governance-standard-list p {
  margin: 10px 0 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.standards-heading {
  margin-top: 88px;
}

.fair-grid h3 {
  margin: 42px 0 10px;
  font: 400 24px/1.15 var(--serif);
}

.standards-profile-list {
  margin-top: 20px;
  border-top: 1px solid var(--line);
}

.standards-profile-list a {
  display: grid;
  grid-template-columns: minmax(190px, 0.45fr) minmax(0, 1fr) auto;
  min-height: 58px;
  align-items: center;
  gap: 24px;
  padding: 10px 16px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-left: 1px solid var(--line);
  background: rgba(255, 254, 249, 0.65);
}

.standards-profile-list span {
  font-size: 10px;
  font-weight: 800;
}

.standards-profile-list p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.passport-field-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.passport-field-grid article {
  min-height: 130px;
  padding: 20px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.passport-field-grid span,
.passport-field-grid strong,
.passport-field-grid small {
  display: block;
}

.passport-field-grid span {
  color: var(--coral);
  font: 400 19px/1 var(--serif);
}

.passport-field-grid strong {
  margin-top: 22px;
  font-size: 10px;
}

.passport-field-grid small {
  margin-top: 7px;
  color: var(--ink-soft);
  font-size: 9px;
}

.research-passport-list {
  border-top: 1px solid var(--line);
}

.research-passport-list > details {
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-left: 1px solid var(--line);
  background: var(--white);
}

.research-passport-list > details > summary {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr) minmax(140px, auto);
  min-height: 92px;
  align-items: center;
  gap: 18px;
  padding: 18px 22px;
  cursor: pointer;
}

.research-passport-list > details > summary > span {
  color: var(--coral);
  font: 400 24px/1 var(--serif);
}

.research-passport-list summary small,
.research-passport-list summary strong {
  display: block;
}

.research-passport-list summary small {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.06em;
}

.research-passport-list summary strong {
  margin-top: 6px;
  font: 400 20px/1.2 var(--serif);
}

.research-passport-list summary b {
  color: var(--teal-dark);
  font-size: 8px;
  text-align: right;
}

.research-passport-body {
  border-top: 1px solid var(--line);
}

.passport-facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.passport-facts > div {
  min-width: 0;
  min-height: 120px;
  padding: 18px 20px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.passport-facts > div:nth-child(3n) {
  border-right: 0;
}

.passport-facts span {
  color: var(--teal);
  font-size: 7px;
  font-weight: 800;
  letter-spacing: 0.09em;
}

.passport-facts p {
  margin: 12px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.research-passport-body footer {
  display: flex;
  min-height: 56px;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 22px;
  padding: 10px 20px;
}

.research-passport-body footer span,
.research-passport-body footer a {
  font-size: 9px;
}

.research-passport-body footer a {
  border-bottom: 1px solid currentColor;
  color: var(--teal-dark);
  font-weight: 800;
}

.passport-evidence-links {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  background: var(--paper);
}

.passport-evidence-links a {
  display: flex;
  min-height: 118px;
  flex-direction: column;
  gap: 8px;
  padding: 18px 20px;
  border-right: 1px solid var(--line);
}

.passport-evidence-links a:nth-child(3n) {
  border-right: 0;
}

.passport-evidence-links strong {
  color: var(--teal-dark);
  font-size: 9px;
}

.passport-evidence-links span,
.passport-evidence-links small {
  color: var(--ink-soft);
  font-size: 8px;
}

.passport-evidence-links small {
  margin-top: auto;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.standards-policy-grid,
.governance-standard-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.standards-policy-grid > article,
.governance-standard-list > article {
  min-height: 220px;
  padding: 27px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.standards-policy-grid h3 {
  margin: 42px 0 10px;
  font: 400 24px/1.15 var(--serif);
}

.governance-standard-list > article {
  min-height: 175px;
}

.governance-standard-list a {
  display: inline-block;
  margin-top: 18px;
  border-bottom: 1px solid currentColor;
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
}

.privacy-effective {
  display: grid;
  grid-template-columns: minmax(240px, 0.55fr) minmax(0, 1.45fr);
  gap: 40px;
  margin-bottom: 90px;
  padding: 32px;
  border-left: 4px solid var(--amber);
  background: #fff9e8;
}

.privacy-effective span,
.privacy-effective strong {
  display: block;
}

.privacy-effective span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.privacy-effective strong {
  margin-top: 8px;
  font: 400 20px/1.2 var(--serif);
}

.privacy-effective p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.release-note-panel {
  display: grid;
  grid-template-columns: minmax(250px, 0.55fr) minmax(0, 1.45fr);
  gap: 42px;
  margin: 0 0 48px;
  padding: 34px;
  border: 1px solid var(--line);
  background: var(--white);
}

.release-note-panel h2 {
  margin: 0;
  font: 400 29px/1.18 var(--serif);
}

.release-note-panel article {
  padding: 13px 0;
  border-bottom: 1px solid var(--line);
}

.release-note-panel article:first-child {
  padding-top: 0;
}

.release-note-panel article:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.release-note-panel article span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.release-note-panel article p {
  margin: 7px 0 0;
  color: var(--ink-soft);
  font-size: 10px;
}

button:focus-visible,
a:focus-visible,
summary:focus-visible,
input:focus-visible {
  outline: 3px solid var(--amber);
  outline-offset: 3px;
}

@media (max-width: 1120px) {
  .header-inner {
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: auto;
    padding-top: 10px;
  }

  .brand {
    grid-column: 1;
    grid-row: 1;
  }

  .header-actions {
    grid-column: 2;
    grid-row: 1;
  }

  .main-nav {
    display: flex;
    grid-column: 1 / -1;
    grid-row: 2;
    width: 100%;
    min-height: 48px;
    align-items: stretch;
    gap: 0;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scrollbar-width: thin;
  }

  .main-nav a {
    display: inline-flex;
    min-height: 44px;
    align-items: center;
    flex: 0 0 auto;
    padding: 8px 13px;
  }

  .standards-release-strip,
  .fair-grid,
  .passport-field-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .dataset-passport-grid,
  .standards-policy-grid,
  .governance-standard-list,
  .passport-facts,
  .passport-evidence-links {
    grid-template-columns: 1fr;
  }

  .dataset-passport-grid > div,
  .dataset-passport-grid > div:nth-child(2n),
  .passport-facts > div,
  .passport-facts > div:nth-child(3n) {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .dataset-passport-grid > div:last-child,
  .passport-facts > div:last-child {
    border-bottom: 0;
  }

  .passport-evidence-links a,
  .passport-evidence-links a:nth-child(3n) {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .passport-evidence-links a:last-child {
    border-bottom: 0;
  }

  .research-passport-list > details > summary {
    grid-template-columns: 34px minmax(0, 1fr);
  }

  .research-passport-list summary b {
    grid-column: 2;
    text-align: left;
  }

  .privacy-effective {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .release-note-panel {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

@media (max-width: 540px) {
  .standards-release-strip,
  .fair-grid,
  .passport-field-grid {
    grid-template-columns: 1fr;
  }

  .standards-profile-list a {
    grid-template-columns: 1fr auto;
    gap: 8px 16px;
    padding: 15px;
  }

  .standards-profile-list p {
    grid-column: 1;
  }

  .dataset-passport summary {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* Reuter 2023 source-bounded explorer */
.reuter-explorer-block {
  margin: 32px 0 56px;
  border: 1px solid var(--line);
  background: var(--white);
}

.reuter-explorer-block > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 28px;
  padding: 30px;
  border-bottom: 1px solid var(--line);
}

.reuter-explorer-block > header h2 {
  max-width: 920px;
  margin: 0;
  font: 400 31px/1.2 var(--serif);
}

.reuter-explorer-block > header > span {
  color: var(--ink-soft);
  font-size: 10px;
}

.reuter-explorer {
  padding: 30px;
}

.reuter-loading,
.cross-gene-state {
  padding: 70px 30px;
  border: 1px solid var(--line);
  background: var(--white);
  color: var(--ink-soft);
  text-align: center;
}

.reuter-loading.error,
.cross-gene-state.error {
  border-left: 4px solid var(--coral);
}

.reuter-gene-tools {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(280px, 0.65fr);
  gap: 24px;
}

.reuter-gene-tools > div > label,
.cross-gene-toolbar label > span {
  display: block;
  margin-bottom: 9px;
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.reuter-gene-tools input,
.cross-gene-toolbar input {
  width: 100%;
  height: 54px;
  padding: 0 17px;
  border: 1px solid var(--line);
  outline: 0;
  background: var(--paper);
  color: var(--ink);
  font: 16px/1 var(--sans);
}

.reuter-gene-tools input:focus,
.cross-gene-toolbar input:focus {
  border-color: var(--teal);
  box-shadow: 0 0 0 3px rgba(11, 117, 108, 0.12);
}

.reuter-gene-tools > article {
  padding: 18px 20px;
  border-left: 3px solid var(--teal);
  background: var(--mint);
}

.reuter-gene-tools > article span,
.reuter-gene-tools > article strong,
.reuter-gene-tools > article code {
  display: block;
}

.reuter-gene-tools > article span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.reuter-gene-tools > article strong {
  margin-top: 7px;
  font: 400 23px/1.15 var(--serif);
}

.reuter-gene-tools > article code {
  margin-top: 6px;
  font-size: 10px;
}

.reuter-gene-tools > article p {
  margin: 8px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.reuter-suggestions {
  position: absolute;
  z-index: 12;
  top: 79px;
  left: 0;
  width: calc(61% - 12px);
  max-height: 360px;
  overflow: auto;
  border: 1px solid var(--line);
  box-shadow: 0 18px 45px rgba(18, 47, 44, 0.16);
  background: var(--white);
}

.reuter-suggestions button {
  display: grid;
  width: 100%;
  grid-template-columns: 0.75fr 1fr;
  gap: 4px 14px;
  padding: 13px 16px;
  border: 0;
  border-bottom: 1px solid var(--line);
  background: transparent;
  color: var(--ink);
  text-align: left;
  cursor: pointer;
}

.reuter-suggestions button:hover,
.reuter-suggestions button:focus-visible {
  background: var(--mint);
}

.reuter-suggestions strong {
  font: 400 15px/1.2 var(--serif);
}

.reuter-suggestions span,
.reuter-suggestions small {
  font-size: 8px;
}

.reuter-suggestions small {
  grid-column: 1 / -1;
  color: var(--ink-soft);
}

.reuter-unit-warning,
.cross-gene-boundary {
  display: grid;
  grid-template-columns: 230px minmax(0, 1fr);
  gap: 20px;
  margin: 25px 0;
  padding: 18px 20px;
  border-left: 4px solid var(--coral);
  background: rgba(217, 107, 77, 0.08);
}

.reuter-unit-warning strong,
.cross-gene-boundary strong {
  color: var(--coral);
  font-size: 9px;
  letter-spacing: 0.1em;
}

.reuter-unit-warning p,
.cross-gene-boundary p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.reuter-plot-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  align-items: start;
  gap: 22px;
}

.reuter-plots {
  min-width: 0;
}

.reuter-plots > section {
  margin-bottom: 22px;
  border: 1px solid var(--line);
}

.reuter-plots > section > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 20px;
  border-bottom: 1px solid var(--line);
}

.reuter-plots header span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.reuter-plots header h3 {
  margin: 5px 0 0;
  font: 400 21px/1.15 var(--serif);
}

.reuter-plots header small {
  max-width: 240px;
  color: var(--ink-soft);
  font-size: 8px;
  text-align: right;
}

.reuter-skin-svg {
  display: block;
  width: 100%;
  min-height: 420px;
  background:
    linear-gradient(rgba(223, 238, 231, 0.33), rgba(255, 254, 249, 0.2));
}

.reuter-skin-svg text {
  fill: var(--ink);
  font: 12px var(--sans);
}

.reuter-skin-svg .count-label {
  fill: var(--ink-soft);
  font-size: 9px;
}

.reuter-skin-svg line {
  stroke: rgba(73, 100, 95, 0.14);
}

.reuter-skin-svg circle {
  cursor: pointer;
  transition: r 120ms ease, stroke-width 120ms ease;
}

.reuter-bsf-grid {
  display: grid;
  grid-template-columns: repeat(16, 1fr);
  gap: 11px;
  padding: 26px;
  background: rgba(247, 246, 239, 0.7);
}

.reuter-bsf-grid button {
  display: grid;
  aspect-ratio: 1;
  padding: 0;
  border: 1px solid var(--ink-soft);
  border-radius: 50%;
  cursor: pointer;
  place-items: center;
}

.reuter-bsf-grid button.active,
.reuter-bsf-grid button:hover,
.reuter-bsf-grid button:focus-visible {
  border: 3px solid #00a6b2;
  outline: 0;
}

.reuter-bsf-grid button span {
  width: 36%;
  aspect-ratio: 1;
  border-radius: 50%;
  background: rgba(18, 47, 44, 0.26);
}

.reuter-summary-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-top: 1px solid var(--line);
}

.reuter-summary-row span {
  padding: 13px 15px;
  border-right: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 8px;
}

.reuter-summary-row span:last-child {
  border-right: 0;
}

.reuter-summary-row strong {
  display: block;
  margin-top: 5px;
  color: var(--ink);
  font-size: 11px;
}

.reuter-cell-card {
  position: sticky;
  top: 105px;
  padding: 24px;
  border-top: 4px solid #00a6b2;
  background: var(--ink);
  color: var(--white);
}

.reuter-cell-card > span {
  color: #99cec9;
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.reuter-cell-card h3 {
  margin: 14px 0 8px;
  overflow-wrap: anywhere;
  font: 400 25px/1.15 var(--serif);
}

.reuter-cell-card > p {
  color: #c9dcd7;
  font-size: 9px;
}

.reuter-cell-card dl {
  margin: 22px 0;
}

.reuter-cell-card dl > div {
  padding: 13px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}

.reuter-cell-card dt {
  color: #99cec9;
  font-size: 8px;
}

.reuter-cell-card dd {
  margin: 6px 0 0;
  overflow-wrap: anywhere;
  font-size: 11px;
}

.reuter-downloads {
  display: grid;
  gap: 8px;
}

.reuter-downloads button {
  padding: 11px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: transparent;
  color: var(--white);
  font-size: 9px;
  cursor: pointer;
}

.reuter-downloads button:hover {
  background: var(--teal);
}

.reuter-layout-note,
.reuter-missing-layer {
  margin: 0;
  padding: 16px 19px;
  color: var(--ink-soft);
  font-size: 9px;
}

.reuter-missing-layer {
  min-height: 160px;
  border-bottom: 1px solid var(--line);
}

.reuter-count-grid {
  grid-template-columns: repeat(6, 1fr);
}

/* Cross-study exact-feature search */
.cross-gene-section {
  padding-top: 58px;
}

.cross-gene-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  gap: 24px;
}

.cross-gene-toolbar > div {
  display: grid;
  min-width: 225px;
  grid-template-columns: auto 1fr;
  align-items: baseline;
  gap: 0 8px;
}

.cross-gene-toolbar > div > strong {
  font: 400 34px/1 var(--serif);
}

.cross-gene-toolbar > div > span {
  color: var(--ink-soft);
  font-size: 9px;
}

.cross-gene-toolbar button {
  grid-column: 1 / -1;
  margin-top: 8px;
  padding: 10px 14px;
  border: 1px solid var(--teal);
  background: transparent;
  color: var(--teal);
  font-size: 9px;
  cursor: pointer;
}

.cross-gene-results {
  border-top: 1px solid var(--line);
}

.cross-gene-results > article {
  display: grid;
  grid-template-columns: 320px minmax(0, 1fr);
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-left: 1px solid var(--line);
  background: var(--white);
}

.cross-gene-results > article > header {
  padding: 24px;
  border-right: 1px solid var(--line);
}

.cross-gene-results > article > header span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.cross-gene-results > article > header h2 {
  margin: 9px 0 8px;
  overflow-wrap: anywhere;
  font: 400 23px/1.1 var(--serif);
}

.cross-gene-results > article > header p {
  color: var(--ink-soft);
  font-size: 9px;
}

.cross-gene-results > article > header > strong {
  display: block;
  margin-top: 20px;
  font-size: 9px;
}

.cross-gene-results > article > div {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.cross-gene-results a {
  min-width: 0;
  padding: 19px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.cross-gene-results a span,
.cross-gene-results a strong,
.cross-gene-results a small,
.cross-gene-results a b {
  display: block;
}

.cross-gene-results a span {
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
}

.cross-gene-results a strong {
  margin-top: 7px;
  font: 400 14px/1.2 var(--serif);
}

.cross-gene-results a small {
  min-height: 27px;
  margin-top: 7px;
  color: var(--ink-soft);
  font-size: 8px;
}

.cross-gene-results a b {
  margin-top: 15px;
  font-size: 8px;
}

.cross-gene-empty {
  padding: 50px;
  border: 1px solid var(--line);
  background: var(--white);
  color: var(--ink-soft);
}

/* Source registry and protected review foundation */
.update-section,
.admin-section {
  padding-top: 58px;
}

.update-status-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.update-status-grid article {
  min-height: 170px;
  padding: 26px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.update-status-grid span,
.admin-identity > span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.update-status-grid strong {
  display: block;
  margin-top: 28px;
  font: 400 25px/1.1 var(--serif);
}

.update-status-grid p {
  color: var(--ink-soft);
  font-size: 9px;
}

.update-status-grid .pending {
  border-top: 4px solid var(--amber);
}

.update-boundary {
  margin: 28px 0 48px;
  padding: 34px;
  border-left: 4px solid var(--coral);
  background: rgba(217, 107, 77, 0.08);
}

.update-boundary h2 {
  margin: 0;
  font: 400 31px/1.2 var(--serif);
}

.update-boundary p {
  max-width: 980px;
  margin: 10px 0 0;
  color: var(--ink-soft);
}

.source-registry-list {
  border-top: 1px solid var(--line);
}

.source-registry-list article {
  display: grid;
  grid-template-columns: minmax(280px, 0.75fr) minmax(0, 1.25fr);
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-left: 1px solid var(--line);
  background: var(--white);
}

.source-registry-list header,
.source-registry-list article > div {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 22px 25px;
}

.source-registry-list header {
  justify-content: space-between;
  border-right: 1px solid var(--line);
}

.source-registry-list header span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.source-registry-list h2 {
  margin: 5px 0 0;
  font: 400 20px/1.15 var(--serif);
}

.source-registry-list header > strong {
  max-width: 135px;
  color: var(--teal);
  font-size: 8px;
  text-align: right;
  text-transform: uppercase;
}

.source-registry-list article > div span {
  color: var(--ink-soft);
  font-size: 8px;
}

.source-registry-list article > div strong {
  display: block;
  margin-top: 4px;
  color: var(--ink);
}

.source-registry-list article > div a {
  margin-left: auto;
  font-size: 9px;
}

.public-review-queue {
  margin-top: 70px;
}

.public-review-queue .section-heading p:last-child {
  max-width: 760px;
  color: var(--ink-soft);
}

.public-review-list {
  display: grid;
  gap: 14px;
}

.public-review-list > article {
  border: 1px solid var(--line);
  background: var(--white);
}

.public-review-list > article > header,
.public-review-list > article > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 22px 25px;
}

.public-review-list > article > header {
  border-bottom: 1px solid var(--line);
}

.public-review-list header span,
.public-review-copy span,
.public-review-list footer > span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.public-review-list h3 {
  margin: 5px 0 0;
  font: 400 22px/1.15 var(--serif);
}

.public-review-list header > strong {
  color: var(--coral);
  font-size: 8px;
  text-transform: uppercase;
}

.public-review-copy {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.public-review-copy > div {
  min-height: 150px;
  padding: 25px;
  border-right: 1px solid var(--line);
}

.public-review-copy > div:last-child {
  border-right: 0;
}

.public-review-copy p {
  margin: 12px 0 0;
  color: var(--ink-soft);
}

.public-review-list > article > footer {
  border-top: 1px solid var(--line);
}

.public-review-list footer div {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;
}

.public-review-list footer a {
  border-bottom: 1px solid rgba(18, 47, 44, 0.28);
  font-size: 9px;
}

.governance-roles {
  margin-top: 70px;
}

.governance-roles > div:last-child {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.governance-roles article {
  padding: 28px;
  border: 1px solid var(--line);
  border-right: 0;
  background: var(--white);
}

.governance-roles article:last-child {
  border-right: 1px solid var(--line);
}

.governance-roles article > span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.governance-roles h3 {
  margin: 10px 0 16px;
  font: 400 25px/1 var(--serif);
}

.governance-roles ul {
  padding-left: 17px;
  color: var(--ink-soft);
  font-size: 9px;
  line-height: 1.7;
}

.admin-identity {
  max-width: 700px;
  padding: 28px;
  border-left: 4px solid var(--teal);
  background: var(--mint);
}

.admin-identity strong,
.admin-identity small {
  display: block;
  margin-top: 9px;
}

.admin-identity strong {
  font: 400 25px/1.15 var(--serif);
}

.admin-identity p {
  color: var(--ink-soft);
  font-size: 9px;
}

.admin-workflow {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin: 35px 0;
  background: var(--ink);
  color: var(--white);
}

.admin-workflow div {
  padding: 24px 18px;
  border-right: 1px solid rgba(255, 255, 255, 0.17);
}

.admin-workflow span,
.admin-workflow strong {
  display: block;
}

.admin-workflow span {
  color: #91c5bd;
  font-size: 9px;
}

.admin-workflow strong {
  margin-top: 22px;
  font: 400 16px/1.2 var(--serif);
}

.admin-queue {
  border: 1px solid var(--line);
  background: var(--white);
}

.admin-queue > header {
  padding: 28px;
  border-bottom: 1px solid var(--line);
}

.admin-queue h2 {
  margin: 0;
  font: 400 28px/1.15 var(--serif);
}

.admin-queue article {
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr) minmax(0, 1fr);
  border-bottom: 1px solid var(--line);
}

.admin-queue article:last-child {
  border-bottom: 0;
}

.admin-queue article > * {
  margin: 0;
  padding: 23px;
  border-right: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 9px;
}

.admin-queue article > *:last-child {
  border-right: 0;
}

.admin-queue article span {
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
}

.admin-queue article h3 {
  margin: 7px 0;
  overflow-wrap: anywhere;
  color: var(--ink);
  font: 400 18px/1.2 var(--serif);
}

@media (max-width: 1040px) {
  .reuter-plot-layout {
    grid-template-columns: minmax(0, 1fr) 250px;
  }

  .reuter-count-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .cross-gene-results > article {
    grid-template-columns: 260px minmax(0, 1fr);
  }

  .cross-gene-results > article > div {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .source-registry-list article {
    grid-template-columns: 1fr;
  }

  .source-registry-list header {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }
}

@media (max-width: 760px) {
  .reuter-explorer-block > header,
  .reuter-plots > section > header {
    flex-direction: column;
  }

  .reuter-explorer {
    padding: 18px;
  }

  .reuter-gene-tools,
  .reuter-plot-layout,
  .cross-gene-toolbar,
  .cross-gene-results > article,
  .public-review-copy,
  .admin-queue article {
    grid-template-columns: 1fr;
  }

  .reuter-suggestions {
    position: static;
    width: 100%;
  }

  .reuter-unit-warning,
  .cross-gene-boundary {
    grid-template-columns: 1fr;
  }

  .reuter-cell-card {
    position: static;
  }

  .reuter-summary-row,
  .update-status-grid,
  .governance-roles > div:last-child {
    grid-template-columns: 1fr;
  }

  .reuter-summary-row span,
  .governance-roles article,
  .admin-queue article > * {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .reuter-bsf-grid {
    grid-template-columns: repeat(8, 1fr);
  }

  .cross-gene-results > article > header {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .source-registry-list article > div {
    align-items: flex-start;
    flex-direction: column;
  }

  .source-registry-list article > div a {
    margin-left: 0;
  }

  .public-review-copy > div {
    min-height: 0;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .public-review-copy > div:last-child {
    border-bottom: 0;
  }

  .public-review-list > article > header,
  .public-review-list > article > footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .admin-workflow {
    grid-template-columns: 1fr;
  }

  .admin-workflow div {
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.17);
  }
}

@media (max-width: 520px) {
  .reuter-count-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .cross-gene-results > article > div {
    grid-template-columns: 1fr;
  }
}

/* Persistent registration, review governance and evidence directories */
.main-nav a {
  padding-right: 9px;
  padding-left: 9px;
}

.workflow-section,
.evidence-directory,
.gene-mapping-section {
  padding-top: 58px;
}

.workflow-shell {
  display: grid;
  gap: 28px;
}

.workflow-identity {
  max-width: 760px;
  padding: 28px;
  border-left: 4px solid var(--teal);
  background: var(--mint);
}

.workflow-identity > span,
.workflow-panel > header > span,
.evidence-audit-summary span,
.mapping-policy span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.workflow-identity strong,
.workflow-identity small {
  display: block;
  margin-top: 8px;
}

.workflow-identity strong {
  font: 400 25px/1.15 var(--serif);
}

.workflow-identity p {
  margin-bottom: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.role-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 17px;
}

.role-chips span,
.status-chip {
  width: fit-content;
  padding: 5px 8px;
  border: 1px solid var(--teal);
  color: var(--teal);
  font-size: 8px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.workflow-message {
  margin: 0;
  padding: 15px 18px;
  border: 1px solid var(--line);
  background: var(--white);
  font-size: 10px;
}

.workflow-message.success {
  border-left: 4px solid var(--teal);
}

.workflow-message.error {
  border-left: 4px solid var(--coral);
  color: #8f251e;
}

.workflow-panel {
  padding: 30px;
  border: 1px solid var(--line);
  background: var(--white);
}

.workflow-panel > header {
  max-width: 900px;
  margin-bottom: 25px;
}

.workflow-panel > header h2 {
  margin: 8px 0 7px;
  font: 400 30px/1.12 var(--serif);
}

.workflow-panel > header p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.workflow-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.workflow-form label,
.review-comment {
  display: block;
}

.workflow-form label > span,
.review-comment > span {
  display: block;
  margin-bottom: 7px;
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
}

.workflow-form input,
.workflow-form select,
.workflow-form textarea,
.review-comment textarea {
  width: 100%;
  min-height: 48px;
  padding: 11px 13px;
  border: 1px solid var(--line);
  border-radius: 0;
  outline: none;
  background: var(--paper);
  color: var(--ink);
  font: 12px/1.4 var(--sans);
}

.workflow-form textarea,
.review-comment textarea {
  min-height: 105px;
  resize: vertical;
}

.workflow-form input:focus,
.workflow-form select:focus,
.workflow-form textarea:focus,
.review-comment textarea:focus {
  border-color: var(--teal);
  box-shadow: 0 0 0 3px rgba(40, 127, 128, 0.11);
}

.workflow-form .form-wide {
  grid-column: 1 / -1;
}

.workflow-form > button {
  align-self: end;
  justify-self: start;
}

.workflow-form button:disabled,
.workflow-panel button:disabled {
  cursor: wait;
  opacity: 0.52;
}

.submission-list,
.review-list,
.user-role-list {
  display: grid;
  border-top: 1px solid var(--line);
}

.submission-list > article {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 25px;
  padding: 21px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.submission-list h3,
.review-list h3 {
  margin: 8px 0 4px;
  font: 400 21px/1.2 var(--serif);
}

.submission-list p,
.review-list p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.submission-list article > div:last-child,
.review-source-links,
.mapping-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.submission-list a,
.review-source-links a,
.mapping-links a {
  padding: 8px 10px;
  border: 1px solid var(--line);
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.workflow-empty {
  margin: 0;
  padding: 35px;
  border: 1px solid var(--line);
  border-top: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.contributor-review-history,
.revision-form {
  grid-column: 1 / -1;
}

.contributor-review-history {
  padding-top: 15px;
  border-top: 1px solid var(--line);
  font-size: 9px;
}

.contributor-review-history summary {
  color: var(--teal);
  cursor: pointer;
  font-weight: 800;
}

.contributor-review-history p {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 12px;
  margin: 0;
  padding: 9px 0;
  border-bottom: 1px dotted var(--line);
  color: var(--ink-soft);
}

.revision-form {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  padding: 18px;
  border-left: 3px solid var(--amber);
  background: #fff8e9;
}

.revision-form label:first-of-type {
  grid-column: 1 / -1;
}

.revision-form label > span {
  display: block;
  margin-bottom: 6px;
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.revision-form input,
.revision-form textarea {
  width: 100%;
  min-height: 44px;
  padding: 9px 11px;
  border: 1px solid var(--line);
  border-radius: 0;
  background: var(--white);
  font: 10px/1.4 var(--sans);
}

.revision-form textarea {
  min-height: 90px;
  resize: vertical;
}

.revision-form button {
  justify-self: start;
}

.review-list > article {
  padding: 25px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.review-list > article > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
}

.review-list > article > header > small {
  color: var(--ink-soft);
  font-size: 8px;
  overflow-wrap: anywhere;
}

.review-source-links {
  margin: 18px 0;
}

.review-facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 0 0 20px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.review-facts > div {
  padding: 15px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.review-facts dt {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.review-facts dd {
  margin: 7px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.review-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 13px;
}

.review-actions button,
.user-role-list button {
  padding: 8px 10px;
  border: 1px solid var(--teal);
  background: transparent;
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  cursor: pointer;
}

.review-actions button:hover,
.user-role-list button.role-assigned {
  background: var(--teal);
  color: var(--white);
}

.review-history {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
  font-size: 9px;
}

.review-history summary {
  color: var(--teal);
  cursor: pointer;
  font-weight: 800;
}

.review-history p {
  display: grid;
  grid-template-columns: 190px 220px 1fr;
  gap: 10px;
  padding: 9px 0;
  border-bottom: 1px dotted var(--line);
}

.review-history em {
  font-style: normal;
}

.source-check-table {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 22px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.source-check-table > div {
  min-width: 0;
  padding: 17px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.source-check-table span,
.source-check-table strong,
.source-check-table small,
.source-check-table a {
  display: block;
}

.source-check-table span {
  width: fit-content;
  padding: 3px 6px;
  color: var(--white);
  font-size: 7px;
  font-weight: 800;
  text-transform: uppercase;
}

.source-reachable {
  background: var(--teal);
}

.source-unreachable {
  background: var(--coral);
}

.source-check-table strong {
  margin-top: 10px;
  font: 400 16px/1.2 var(--serif);
}

.source-check-table small {
  margin-top: 5px;
  color: var(--ink-soft);
  font-size: 8px;
}

.source-check-table a {
  margin-top: 12px;
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.user-role-list > article {
  display: grid;
  grid-template-columns: minmax(230px, 0.6fr) minmax(0, 1.4fr);
  gap: 25px;
  padding: 20px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.user-role-list strong,
.user-role-list small,
.user-role-list em {
  display: block;
}

.user-role-list small,
.user-role-list p,
.user-role-list em {
  margin: 4px 0 0;
  color: var(--ink-soft);
  font-size: 8px;
  font-style: normal;
}

.user-role-list article > div:last-child {
  display: flex;
  flex-wrap: wrap;
  align-content: start;
  gap: 7px;
}

.evidence-audit-summary {
  display: grid;
  grid-template-columns: 0.5fr 1.6fr 0.7fr;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.evidence-audit-summary > div {
  padding: 22px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.evidence-audit-summary strong {
  display: block;
  margin-top: 8px;
  font: 400 17px/1.25 var(--serif);
}

.evidence-caveat {
  margin: 0 0 28px;
  padding: 15px 20px;
  border-left: 4px solid var(--amber);
  background: #fff5df;
  color: var(--ink-soft);
  font-size: 9px;
}

.evidence-card-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.evidence-card-grid article {
  display: flex;
  min-height: 420px;
  flex-direction: column;
  padding: 26px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.evidence-card-grid header > span {
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.evidence-card-grid h2 {
  margin: 10px 0 3px;
  font: 400 27px/1.1 var(--serif);
}

.evidence-card-grid header > strong {
  color: var(--teal);
  font-size: 9px;
}

.evidence-card-grid dl {
  margin: 21px 0;
}

.evidence-card-grid dl > div {
  padding: 12px 0;
  border-top: 1px solid var(--line);
}

.evidence-card-grid dt {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.evidence-card-grid dd {
  margin: 5px 0 0;
  color: var(--ink-soft);
  font-size: 9px;
}

.evidence-card-grid footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: auto;
}

.evidence-card-grid footer a {
  padding: 8px 10px;
  border: 1px solid var(--line);
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.mapping-audit-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.mapping-audit-grid > div {
  padding: 22px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.mapping-audit-grid span,
.mapping-audit-grid strong,
.mapping-audit-grid small {
  display: block;
}

.mapping-audit-grid span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
}

.mapping-audit-grid strong {
  margin-top: 11px;
  font: 400 24px/1 var(--serif);
}

.mapping-audit-grid small {
  margin-top: 6px;
  color: var(--ink-soft);
  font-size: 8px;
}

.mapping-policy {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 25px;
  background: var(--ink);
  color: var(--white);
}

.mapping-policy > div {
  padding: 22px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.mapping-policy p {
  margin: 8px 0 0;
  color: #d1dad8;
  font-size: 9px;
}

.mapping-links {
  margin-top: 15px;
}

.current-id {
  display: block;
  margin-bottom: 8px;
  color: var(--teal);
  font-size: 8px;
  overflow-wrap: anywhere;
}

@media (max-width: 1040px) {
  .source-check-table,
  .mapping-audit-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .workflow-form,
  .revision-form,
  .review-facts,
  .source-check-table,
  .user-role-list > article,
  .evidence-audit-summary,
  .evidence-card-grid,
  .mapping-audit-grid,
  .mapping-policy {
    grid-template-columns: 1fr;
  }

  .workflow-form .form-wide {
    grid-column: auto;
  }

  .submission-list > article,
  .review-list > article > header {
    align-items: flex-start;
    flex-direction: column;
  }

  .submission-list > article {
    grid-template-columns: 1fr;
  }

  .review-history p {
    grid-template-columns: 1fr;
  }
}

/* Member directory: role-led academic profiles with explicit identity status */
.team-hero {
  padding-bottom: 54px;
  border-bottom: 1px solid var(--line);
}

.team-hero h1 {
  max-width: 900px;
}

.team-disclosure {
  display: grid;
  grid-template-columns: minmax(0, 1.05fr) minmax(320px, 0.95fr);
  gap: 64px;
  padding-top: 42px;
  padding-bottom: 42px;
  border-bottom: 1px solid var(--line);
}

.team-disclosure span {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.13em;
}

.team-disclosure h2 {
  max-width: 720px;
  margin: 10px 0 0;
  font: 400 clamp(26px, 3.5vw, 42px)/1.08 var(--serif);
}

.team-disclosure > p {
  align-self: end;
  max-width: 620px;
  margin: 0;
  color: var(--ink-soft);
  font-size: 12px;
}

.team-section {
  padding-top: 70px;
  padding-bottom: 70px;
  border-bottom: 1px solid var(--line);
}

.team-section-heading {
  display: grid;
  grid-template-columns: 240px 1fr;
  align-items: end;
  margin-bottom: 36px;
}

.team-section-heading p {
  margin: 0 0 7px;
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.13em;
}

.team-section-heading h2 {
  margin: 0;
  font: 400 clamp(32px, 4vw, 48px)/1 var(--serif);
}

.team-profile {
  display: grid;
  grid-template-columns: 230px minmax(0, 1fr);
  max-width: 1040px;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.5);
}

.team-portrait {
  display: grid;
  position: relative;
  min-height: 300px;
  padding: 26px;
  border-right: 1px solid var(--line);
  background:
    radial-gradient(circle at 34% 30%, rgba(197, 58, 50, 0.22) 0 4px, transparent 5px),
    radial-gradient(circle at 66% 63%, rgba(40, 127, 128, 0.25) 0 5px, transparent 6px),
    linear-gradient(145deg, #eee9e4, #fbfaf8);
  place-items: center;
}

.team-portrait::before,
.team-portrait::after {
  position: absolute;
  width: 146px;
  height: 48px;
  border: 1px solid rgba(145, 137, 150, 0.7);
  border-radius: 50%;
  content: "";
  transform: rotate(30deg);
}

.team-portrait::after {
  transform: rotate(-30deg);
}

.team-portrait > span {
  z-index: 1;
  display: grid;
  width: 66px;
  height: 66px;
  border: 1px solid var(--ink);
  border-radius: 50%;
  background: var(--white);
  color: var(--ink);
  font: 800 18px/1 var(--sans);
  place-items: center;
}

.team-portrait small {
  position: absolute;
  right: 20px;
  bottom: 18px;
  left: 20px;
  color: var(--ink-soft);
  font-size: 8px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-align: center;
  text-transform: uppercase;
}

.team-profile-copy {
  padding: 38px 44px;
}

.team-profile-state {
  display: inline-flex;
  padding: 5px 9px;
  border: 1px solid rgba(197, 58, 50, 0.35);
  background: rgba(197, 58, 50, 0.06);
  color: var(--coral);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.team-profile-copy h3 {
  margin: 16px 0 4px;
  color: var(--coral);
  font: 400 clamp(29px, 3.5vw, 42px)/1.08 var(--serif);
}

.team-profile-role {
  margin: 0;
  font-size: 13px;
  font-weight: 800;
}

.team-profile-description {
  max-width: 720px;
  margin: 22px 0 26px;
  color: var(--ink-soft);
  font-size: 11px;
}

.team-profile-facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.team-profile-field {
  min-width: 0;
  padding: 16px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.team-profile-field small,
.team-profile-field strong {
  display: block;
}

.team-profile-field small {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.team-profile-field strong {
  margin-top: 8px;
  overflow-wrap: anywhere;
  font-size: 10px;
}

.team-role-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.team-role-card {
  min-height: 255px;
  padding: 32px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.team-role-card > span {
  color: var(--coral);
  font: 400 22px/1 var(--serif);
}

.team-role-card h3 {
  margin: 44px 0 12px;
  font: 400 28px/1.08 var(--serif);
}

.team-role-card p {
  max-width: 520px;
  margin: 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.team-role-card strong {
  display: block;
  margin-top: 22px;
  color: var(--teal);
  font-size: 9px;
}

.team-empty-state {
  display: grid;
  grid-template-columns: 130px minmax(0, 1fr);
  max-width: 1040px;
  border: 1px solid var(--line);
  background: var(--white);
}

.team-empty-state > div:first-child {
  display: grid;
  min-height: 170px;
  border-right: 1px solid var(--line);
  background: var(--plum-light);
  color: var(--coral);
  font: 400 54px/1 var(--serif);
  place-items: center;
}

.team-empty-state > div:last-child {
  padding: 32px 38px;
}

.team-empty-state h3 {
  margin: 0;
  font: 400 27px/1.1 var(--serif);
}

.team-empty-state p {
  max-width: 760px;
  margin: 16px 0 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.team-publish-checklist {
  display: grid;
  grid-template-columns: minmax(300px, 0.8fr) minmax(0, 1.2fr);
  gap: 76px;
  padding-top: 78px;
  padding-bottom: 96px;
}

.team-publish-checklist h2 {
  margin: 8px 0 18px;
  font: 400 clamp(30px, 4vw, 46px)/1.05 var(--serif);
}

.team-publish-checklist > div > p:last-child {
  color: var(--ink-soft);
  font-size: 11px;
}

.team-publish-checklist ul {
  margin: 0;
  padding: 0;
  border-top: 1px solid var(--line);
  list-style: none;
}

.team-publish-checklist li {
  display: grid;
  grid-template-columns: 52px 1fr;
  padding: 16px 0;
  border-bottom: 1px solid var(--line);
  font-size: 11px;
  font-weight: 700;
}

.team-publish-checklist li > span:first-child {
  color: var(--coral);
  font-family: var(--serif);
}

@media (min-width: 1121px) and (max-width: 1320px) {
  .main-nav a {
    padding-right: 9px;
    padding-left: 9px;
  }
}

@media (max-width: 820px) {
  .team-disclosure,
  .team-publish-checklist {
    grid-template-columns: 1fr;
    gap: 28px;
  }

  .team-section-heading {
    grid-template-columns: 1fr;
    gap: 6px;
  }

  .team-profile {
    grid-template-columns: 180px minmax(0, 1fr);
  }

  .team-portrait {
    min-height: 100%;
  }

  .team-profile-copy {
    padding: 30px;
  }

  .team-profile-facts {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .team-profile,
  .team-role-grid,
  .team-empty-state {
    grid-template-columns: 1fr;
  }

  .team-portrait {
    min-height: 230px;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .team-profile-copy,
  .team-role-card,
  .team-empty-state > div:last-child {
    padding: 25px;
  }

  .team-empty-state > div:first-child {
    min-height: 90px;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }
}

/* Compact About page: short introduction, verified people, direct contact */
.about-hero {
  max-width: 1120px;
  padding-top: 74px;
  padding-bottom: 48px;
  border-bottom: 1px solid var(--line);
}

.about-hero h1 {
  max-width: 820px;
}

.about-hero > p:last-child {
  max-width: 780px;
}

.about-team-section {
  padding-top: 58px;
  padding-bottom: 62px;
  border-bottom: 1px solid var(--line);
}

.about-section-heading {
  display: grid;
  grid-template-columns: minmax(240px, 0.7fr) minmax(320px, 1fr);
  gap: 48px;
  align-items: end;
  margin-bottom: 30px;
}

.about-section-heading p {
  margin: 0;
}

.about-section-heading > div > p {
  color: var(--coral);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.13em;
}

.about-section-heading h2 {
  margin: 8px 0 0;
  font: 400 clamp(30px, 4vw, 46px)/1.05 var(--serif);
}

.about-section-heading > p {
  max-width: 620px;
  color: var(--ink-soft);
  font-size: 11px;
}

.about-member-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.about-member-card {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.54);
}

.about-member-portrait {
  min-height: 220px;
  overflow: hidden;
  border-right: 1px solid var(--line);
  background: var(--plum-light);
}

.about-member-portrait img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 220px;
  object-fit: cover;
  object-position: center 32%;
}

.about-member-copy {
  padding: 28px 34px;
}

.about-member-copy h3 {
  margin: 0;
  color: var(--coral);
  font: 400 clamp(25px, 3vw, 34px)/1.08 var(--serif);
}

.about-member-copy > strong {
  display: block;
  margin-top: 7px;
  font-size: 11px;
}

.about-member-copy > p {
  max-width: 680px;
  margin: 17px 0 21px;
  color: var(--ink-soft);
  font-size: 10px;
}

.about-member-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 22px;
  padding-top: 14px;
  border-top: 1px solid var(--line);
}

.about-member-links span,
.about-member-links a {
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
}

.about-member-links a {
  text-decoration-color: rgba(40, 127, 128, 0.38);
  text-underline-offset: 3px;
}

.about-contact-section {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 48px;
  align-items: end;
  padding-top: 56px;
  padding-bottom: 76px;
}

.about-contact-section h2 {
  margin: 8px 0 14px;
  font: 400 clamp(28px, 4vw, 42px)/1.06 var(--serif);
}

.about-contact-section > div:first-child > p:last-child {
  max-width: 700px;
  margin-bottom: 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.about-contact-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-end;
}

@media (max-width: 720px) {
  .about-section-heading,
  .about-contact-section {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .about-contact-actions {
    justify-content: flex-start;
  }
}

.submission-admin {
  max-width: 1180px;
  min-height: 100vh;
  margin: 0 auto;
  padding-top: clamp(2rem, 6vw, 5rem);
}

.submission-admin > header {
  max-width: 780px;
  margin-bottom: 2rem;
}

.submission-admin > header h1 {
  margin: 0.6rem 0 1rem;
  font-size: clamp(2.3rem, 6vw, 5.2rem);
  line-height: 0.96;
}

.admin-auth-panel {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) auto auto;
  gap: 0.75rem;
  align-items: end;
  padding: 1.25rem;
  border: 1px solid var(--line);
  background: #fff;
}

.admin-auth-panel label,
.admin-review-form label {
  display: grid;
  gap: 0.45rem;
  color: var(--ink-soft);
  font-size: 0.82rem;
  font-weight: 700;
}

.admin-auth-panel input,
.admin-review-form select,
.admin-review-form textarea {
  width: 100%;
  border: 1px solid #aaa3aa;
  border-radius: 0;
  background: #fff;
  padding: 0.78rem;
  color: var(--ink);
  font: inherit;
}

.admin-queue {
  display: grid;
  gap: 1.25rem;
  margin-top: 1.5rem;
}

.admin-queue > article {
  border: 1px solid var(--line);
  background: #fff;
  padding: clamp(1rem, 3vw, 2rem);
}

.admin-queue > article > header {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  border-bottom: 1px solid var(--line);
  padding-bottom: 1rem;
}

.admin-queue > article > header span,
.admin-queue > article > header > strong {
  color: var(--teal);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.admin-queue h2 {
  margin: 0.35rem 0;
  font-size: clamp(1.4rem, 3vw, 2.4rem);
}

.admin-queue dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin: 1rem 0;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.admin-queue dl > div {
  min-width: 0;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  padding: 0.75rem;
}

.admin-queue dt {
  color: var(--ink-soft);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.admin-queue dd {
  overflow-wrap: anywhere;
  margin: 0.3rem 0 0;
}

.admin-queue pre {
  overflow: auto;
  max-height: 320px;
  padding: 1rem;
  background: #f2f0f2;
  white-space: pre-wrap;
}

.admin-review-form {
  display: grid;
  grid-template-columns: minmax(180px, 0.7fr) 1fr 1fr auto;
  gap: 0.75rem;
  align-items: end;
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--line);
}

.admin-terminal-state {
  margin: 1rem 0 0;
  color: var(--ink-soft);
}

@media (max-width: 900px) {
  .admin-auth-panel,
  .admin-review-form {
    grid-template-columns: 1fr;
    align-items: stretch;
  }

  .admin-queue dl {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 1080px) {
  .about-member-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 520px) {
  .about-member-card {
    grid-template-columns: 1fr;
  }

  .about-member-portrait {
    min-height: 0;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }

  .about-member-portrait img {
    height: auto;
    min-height: 0;
    aspect-ratio: 1;
  }

  .about-member-copy {
    padding: 25px;
  }
}

/* Compact sticky navigation after the reader leaves the page introduction */
.site-header {
  transition: box-shadow 180ms ease;
}

.header-inner {
  transition:
    min-height 180ms ease,
    padding 180ms ease,
    row-gap 180ms ease;
}

.brand {
  transition: gap 180ms ease;
}

.brand-mark {
  transition:
    width 180ms ease,
    height 180ms ease;
}

.brand strong {
  transition: font-size 180ms ease;
}

.brand small {
  max-height: 18px;
  overflow: hidden;
  opacity: 1;
  transition:
    max-height 140ms ease,
    opacity 120ms ease;
}

.main-nav,
.main-nav a,
.language-toggle {
  transition:
    min-height 180ms ease,
    padding 180ms ease,
    gap 180ms ease,
    font-size 180ms ease;
}

.site-header.is-compact {
  box-shadow: 0 7px 24px rgba(23, 23, 25, 0.08);
}

.site-header.is-compact .header-inner {
  grid-template-columns: minmax(265px, 1fr) auto minmax(90px, auto);
  min-height: 66px;
}

.site-header.is-compact .brand {
  gap: 11px;
}

.site-header.is-compact .brand-mark {
  width: 44px;
  height: 44px;
}

.site-header.is-compact .brand-mark::before,
.site-header.is-compact .brand-mark::after {
  width: 32px;
  height: 12px;
}

.site-header.is-compact .brand-mark i {
  width: 4px;
  height: 4px;
}

.site-header.is-compact .brand-mark i:nth-child(1) {
  top: 8px;
  left: 20px;
}

.site-header.is-compact .brand-mark i:nth-child(2) {
  top: 19px;
  left: 8px;
}

.site-header.is-compact .brand-mark i:nth-child(3) {
  top: 21px;
  right: 7px;
}

.site-header.is-compact .brand-mark i:nth-child(4) {
  bottom: 7px;
  left: 17px;
}

.site-header.is-compact .brand-mark i:nth-child(5) {
  right: 14px;
  bottom: 10px;
}

.site-header.is-compact .brand strong {
  font-size: 24px;
}

.site-header.is-compact .brand small {
  max-height: 0;
  opacity: 0;
}

.site-header.is-compact .main-nav a {
  padding-right: 9px;
  padding-left: 9px;
  font-size: 12px;
}

.site-header.is-compact .language-toggle {
  min-width: 44px;
  padding: 5px 9px;
  font-size: 11px;
}

@media (max-width: 1120px) {
  .site-header .header-inner {
    row-gap: 0;
  }

  .site-header:not(.is-compact) .brand {
    gap: 14px;
  }

  .site-header:not(.is-compact) .brand-mark {
    width: 52px;
    height: 52px;
  }

  .site-header:not(.is-compact) .brand-mark::before,
  .site-header:not(.is-compact) .brand-mark::after {
    width: 38px;
    height: 14px;
  }

  .site-header:not(.is-compact) .brand-mark i:nth-child(1) {
    top: 9px;
    left: 24px;
  }

  .site-header:not(.is-compact) .brand-mark i:nth-child(2) {
    top: 22px;
    left: 10px;
  }

  .site-header:not(.is-compact) .brand-mark i:nth-child(3) {
    top: 24px;
    right: 9px;
  }

  .site-header:not(.is-compact) .brand-mark i:nth-child(4) {
    bottom: 8px;
    left: 20px;
  }

  .site-header:not(.is-compact) .brand-mark i:nth-child(5) {
    right: 17px;
    bottom: 12px;
  }

  .site-header:not(.is-compact) .brand strong {
    font-size: 24px;
  }

  .site-header .main-nav {
    justify-content: safe center;
    padding-right: 16px;
    padding-left: 16px;
  }

  .site-header.is-compact .header-inner {
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: auto;
    row-gap: 0;
    padding-top: 4px;
  }

  .site-header.is-compact .main-nav {
    min-height: 36px;
  }

  .site-header.is-compact .main-nav a {
    min-height: 34px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

@media (max-width: 540px) {
  .site-header .main-nav {
    padding-right: 0;
    padding-left: 0;
  }

  .site-header.is-compact .brand strong {
    font-size: 18px;
  }

  .site-header.is-compact .brand-mark {
    width: 40px;
    height: 40px;
  }

  .site-header.is-compact .main-nav a {
    font-size: 10px;
  }
}

@media (min-width: 641px) and (max-width: 1120px) {
  .site-header .header-inner,
  .site-header.is-compact .header-inner {
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    min-height: 72px;
    padding-top: 0;
    column-gap: clamp(10px, 2vw, 28px);
    row-gap: 0;
  }

  .site-header.is-compact .header-inner {
    min-height: 60px;
  }

  .site-header .brand {
    grid-column: 1;
    grid-row: 1;
    min-width: 0;
  }

  .site-header .brand small {
    display: none;
  }

  .site-header .header-actions {
    grid-column: 3;
    grid-row: 1;
  }

  .site-header .main-nav,
  .site-header.is-compact .main-nav {
    grid-column: 2;
    grid-row: 1;
    width: auto;
    min-height: 60px;
    align-items: center;
    padding: 0;
    justify-content: center;
    overflow: visible;
  }

  .site-header .main-nav a,
  .site-header.is-compact .main-nav a {
    display: inline-block;
    min-height: 0;
    padding: 0 9px;
    line-height: 1.2;
  }
}

@media (min-width: 641px) and (max-width: 760px) {
  .site-header .brand {
    gap: 0;
  }

  .site-header .brand-mark {
    display: none;
  }

  .site-header .brand strong,
  .site-header.is-compact .brand strong {
    font-size: 18px;
  }

  .site-header .main-nav a,
  .site-header.is-compact .main-nav a {
    padding-right: 7px;
    padding-left: 7px;
    font-size: 11px;
  }
}

/* Public contribution and guide: no account, private scientific review */
.button-dark {
  border-color: var(--ink);
  background: var(--ink);
  color: var(--white);
}

.guide-hero,
.submit-hero {
  border-bottom: 1px solid var(--line);
}

.guide-section,
.submission-section {
  padding-top: 58px;
  padding-bottom: 110px;
}

.guide-layout {
  display: block;
}

.guide-nav {
  position: relative;
  z-index: 1;
  margin-bottom: 58px;
  border: 1px solid var(--line);
  border-top: 2px solid var(--ink);
  background: rgba(255, 255, 255, 0.97);
  backdrop-filter: blur(10px);
}

.guide-nav-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 13px 16px 11px;
  border-bottom: 1px solid var(--line);
}

.guide-nav-heading strong {
  color: var(--teal);
  font-size: 9px;
  letter-spacing: 0.12em;
}

.guide-nav-heading small {
  color: var(--ink-soft);
  font-size: 9px;
}

.guide-nav nav {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.guide-nav a {
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: center;
  gap: 8px;
  min-height: 54px;
  padding: 11px 13px;
  border-right: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 10.5px;
  font-weight: 700;
}

.guide-nav a:last-child {
  border-right: 0;
}

.guide-nav a:hover,
.guide-nav a:focus-visible {
  color: var(--coral);
}

.guide-nav small {
  color: var(--plum);
}

.guide-content {
  min-width: 0;
  max-width: 1040px;
  margin: 0 auto;
}

.guide-content > section {
  max-width: 940px;
  padding: 0 0 62px;
  scroll-margin-top: 88px;
}

.guide-content > section + section {
  padding-top: 62px;
  border-top: 1px solid var(--line);
}

.guide-content h2 {
  max-width: 800px;
  margin: 0;
  font: 400 clamp(34px, 4.5vw, 54px)/1.03 var(--serif);
  letter-spacing: -0.035em;
}

.guide-content section > p:not(.section-number) {
  max-width: 840px;
  margin: 24px 0 0;
  color: var(--ink-soft);
  font-size: 13px;
  line-height: 1.8;
}

.guide-goal-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 32px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.guide-goal-grid article {
  display: flex;
  min-height: 245px;
  padding: 24px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
  flex-direction: column;
}

.guide-goal-grid article > span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.11em;
}

.guide-goal-grid h3 {
  margin: 28px 0 9px;
  font: 400 25px/1.12 var(--serif);
}

.guide-goal-grid p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.guide-goal-grid a {
  width: fit-content;
  margin-top: auto;
  padding-top: 20px;
  color: var(--teal-dark);
  font-size: 9px;
  font-weight: 800;
  text-decoration: underline;
  text-decoration-color: rgba(40, 127, 128, 0.32);
  text-underline-offset: 3px;
}

.guide-goal-grid .guide-secondary-link {
  margin-top: 7px;
  padding-top: 0;
  color: var(--ink-soft);
}

.guide-search-examples {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 30px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.guide-search-examples article {
  min-height: 130px;
  padding: 21px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.guide-search-examples code {
  display: inline-block;
  padding: 5px 8px;
  background: var(--mint);
  color: var(--teal-dark);
  font-size: 11px;
  font-weight: 800;
}

.guide-search-examples p {
  margin: 17px 0 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.guide-primary-action {
  display: inline-flex;
  margin-top: 28px;
}

.guide-steps {
  display: grid;
  margin: 32px 0 0;
  padding: 0;
  border-top: 1px solid var(--line);
  list-style: none;
}

.guide-steps li {
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  align-items: start;
  padding: 16px 0;
  border-bottom: 1px solid var(--line);
  font-size: 11px;
}

.guide-steps li > span:first-child {
  color: var(--coral);
  font: 400 21px/1 var(--serif);
}

.guide-card-grid,
.guide-layer-grid,
.guide-submit-grid {
  display: grid;
  margin-top: 34px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.guide-card-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.guide-layer-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.guide-submit-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 30px;
}

.guide-card-grid article,
.guide-layer-grid article,
.guide-submit-grid article {
  padding: 25px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.guide-card-grid strong,
.guide-submit-grid strong {
  font: 400 22px/1.15 var(--serif);
}

.guide-card-grid p,
.guide-layer-grid p {
  margin: 28px 0 0;
  color: var(--ink-soft);
  font-size: 10px;
}

.guide-layer-grid span {
  color: var(--teal);
  font-size: 8px;
  font-weight: 800;
  letter-spacing: 0.09em;
}

.guide-note {
  margin-top: 24px;
  padding: 22px 25px;
  border-left: 4px solid var(--amber);
  background: #fff8e7;
}

.guide-note p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.guide-definitions {
  margin: 34px 0 0;
  border-top: 1px solid var(--line);
}

.guide-definitions > div {
  display: grid;
  grid-template-columns: minmax(140px, 0.32fr) minmax(0, 1fr);
  gap: 35px;
  padding: 22px 0;
  border-bottom: 1px solid var(--line);
}

.guide-definitions dt {
  color: var(--teal);
  font: 400 22px/1.15 var(--serif);
}

.guide-definitions dd {
  margin: 0;
  color: var(--ink-soft);
  font-size: 11px;
  line-height: 1.75;
}

.guide-checklist,
.guide-submit-grid ul {
  margin: 26px 0 0;
  padding: 0;
  list-style: none;
}

.guide-checklist li,
.guide-submit-grid li {
  position: relative;
  padding: 11px 0 11px 22px;
  border-bottom: 1px solid var(--line);
  color: var(--ink-soft);
  font-size: 11px;
}

.guide-checklist li::before,
.guide-submit-grid li::before {
  position: absolute;
  top: 15px;
  left: 2px;
  width: 6px;
  height: 6px;
  border: 1px solid var(--teal);
  content: "";
}

.guide-submit-grid article:last-child li::before {
  border-color: var(--coral);
}

.guide-review-flow {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-top: 34px;
  border-top: 1px solid var(--ink);
  border-left: 1px solid var(--line);
}

.guide-review-flow div {
  min-height: 130px;
  padding: 18px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.guide-review-flow span,
.guide-review-flow strong,
.guide-review-flow small {
  display: block;
}

.guide-review-flow span {
  color: var(--coral);
  font: 400 20px/1 var(--serif);
}

.guide-review-flow strong {
  margin-top: 30px;
  font-size: 10px;
}

.guide-review-flow small {
  margin-top: 4px;
  color: var(--ink-soft);
  font-size: 9px;
}

.guide-link-row,
.submission-template-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 28px;
}

.guide-link-row a,
.submission-template-actions a {
  padding: 9px 11px;
  border: 1px solid var(--line);
  background: var(--white);
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
}

.guide-source-links {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 28px;
  border-top: 1px solid var(--line);
  border-left: 1px solid var(--line);
}

.guide-source-links a {
  min-width: 0;
  padding: 18px;
  border-right: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  background: var(--white);
}

.guide-source-links strong,
.guide-source-links span {
  display: block;
}

.guide-source-links strong {
  color: var(--teal);
  font-size: 10px;
}

.guide-source-links span {
  margin-top: 6px;
  color: var(--ink-soft);
  font-size: 9px;
}

.public-submission-shell {
  display: grid;
  gap: 28px;
}

.submission-unavailable {
  padding: 26px 28px;
  border-left: 4px solid var(--amber);
  background: #fff8e7;
}

.submission-unavailable strong {
  font: 400 25px/1.15 var(--serif);
}

.submission-unavailable p {
  max-width: 800px;
  margin: 10px 0 18px;
  color: var(--ink-soft);
  font-size: 11px;
}

.submission-panel,
.submission-receipt {
  padding: clamp(24px, 4vw, 42px);
  border: 1px solid var(--line);
  background: var(--white);
}

.submission-panel > header {
  max-width: 900px;
  margin-bottom: 32px;
}

.submission-panel > header > span,
.submission-receipt > div:first-child > span,
.submission-form-divider {
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.1em;
}

.submission-panel > header h2,
.submission-receipt h2 {
  margin: 10px 0 8px;
  font: 400 clamp(29px, 3vw, 40px)/1.1 var(--serif);
}

.submission-panel > header p,
.submission-receipt p {
  margin: 0;
  color: var(--ink-soft);
  font-size: 11px;
}

.submission-form-divider {
  margin-top: 12px;
  padding: 14px 0 5px;
  border-bottom: 1px solid var(--ink);
}

.anonymous-submission-form label small {
  display: block;
  margin-top: 6px;
  color: var(--ink-soft);
  font-size: 8px;
  overflow-wrap: anywhere;
}

.anonymous-submission-form input[type="file"] {
  padding: 10px;
  font-size: 10px;
}

.anonymous-submission-form .submission-consent {
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  align-items: start;
  gap: 10px;
  padding: 14px;
  border: 1px solid var(--line);
  background: var(--paper);
}

.anonymous-submission-form .submission-consent input {
  width: 16px;
  min-height: 16px;
  margin: 3px 0 0;
}

.anonymous-submission-form .submission-consent > span {
  margin: 0;
  color: var(--ink-soft);
  font-size: 10px;
  font-weight: 400;
  line-height: 1.65;
}

.anonymous-submission-form .submission-consent a {
  color: var(--teal);
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.submission-honeypot {
  position: absolute !important;
  left: -10000px !important;
  width: 1px !important;
  height: 1px !important;
  overflow: hidden !important;
}

.submission-receipt {
  border-left: 5px solid var(--teal);
  background: var(--mint);
}

.submission-receipt dl {
  display: grid;
  grid-template-columns: 1fr 1.4fr 0.7fr;
  margin: 25px 0;
  border-top: 1px solid rgba(23, 23, 25, 0.25);
  border-left: 1px solid rgba(23, 23, 25, 0.25);
}

.submission-receipt dl > div {
  min-width: 0;
  padding: 16px;
  border-right: 1px solid rgba(23, 23, 25, 0.25);
  border-bottom: 1px solid rgba(23, 23, 25, 0.25);
}

.submission-receipt dt {
  color: var(--ink-soft);
  font-size: 8px;
  font-weight: 800;
}

.submission-receipt dd {
  margin: 8px 0 0;
  overflow-wrap: anywhere;
  font-size: 10px;
  font-weight: 700;
}

.status-lookup-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  align-items: end;
  gap: 16px;
}

.status-lookup-form label,
.status-lookup-form label > span {
  display: block;
}

.status-lookup-form label > span {
  margin-bottom: 7px;
  color: var(--teal);
  font-size: 9px;
  font-weight: 800;
}

.status-lookup-form input {
  width: 100%;
  min-height: 48px;
  padding: 11px 13px;
  border: 1px solid var(--line);
  background: var(--paper);
  color: var(--ink);
  font-size: 11px;
}

.submission-status-result {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px 18px;
  margin-top: 22px;
  padding: 18px;
  border-left: 4px solid var(--teal);
  background: var(--mint);
}

.submission-status-result span,
.submission-status-result small {
  color: var(--ink-soft);
  font-size: 9px;
  overflow-wrap: anywhere;
}

.submission-status-result strong {
  grid-row: 1 / 3;
  grid-column: 2;
  align-self: center;
  font: 400 22px/1 var(--serif);
}

.submission-status-result p {
  grid-column: 1 / -1;
  margin: 8px 0 0;
  padding-top: 12px;
  border-top: 1px solid rgba(23, 23, 25, 0.15);
  color: var(--ink-soft);
  font-size: 10px;
}

@media (max-width: 900px) {
  .guide-nav nav {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .guide-nav a {
    border-bottom: 1px solid var(--line);
  }

  .guide-nav a:nth-child(3n) {
    border-right: 0;
  }

  .guide-nav a:nth-last-child(-n + 3) {
    border-bottom: 0;
  }

  .guide-review-flow {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .status-lookup-form {
    grid-template-columns: 1fr 1fr;
  }

  .status-lookup-form button {
    grid-column: 1 / -1;
    justify-self: start;
  }
}

@media (max-width: 640px) {
  .guide-nav-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 5px;
  }

  .guide-nav nav {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .guide-nav a:nth-child(3n) {
    border-right: 1px solid var(--line);
  }

  .guide-nav a:nth-child(2n) {
    border-right: 0;
  }

  .guide-nav a:nth-last-child(-n + 3) {
    border-bottom: 1px solid var(--line);
  }

  .guide-nav a:nth-last-child(-n + 2) {
    border-bottom: 0;
  }

  .guide-goal-grid,
  .guide-search-examples,
  .guide-card-grid,
  .guide-layer-grid,
  .guide-submit-grid,
  .guide-source-links,
  .guide-review-flow,
  .submission-receipt dl,
  .status-lookup-form {
    grid-template-columns: 1fr;
  }

  .guide-definitions > div {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .submission-status-result {
    grid-template-columns: 1fr;
  }

  .submission-status-result strong {
    grid-row: auto;
    grid-column: auto;
  }
}
